import * as React from "react";

// import  {
//   withStyles,
//   WithStyles,
//   StyleRules,
//   ClassNameMap,
// } from '@mui/styles';


// import {withStyles} from '@mui/styles'

import  { withStyles } from '@mui/styles';
import * as _ from "lodash";
import {
	WithStyles,
	StyleRules,
	ClassNameMap
  } from '@mui/styles/withStyles';

import { Theme } from "@mui/styles";
import {
  TextField,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Select,
  Switch,
  Checkbox,
  Radio,
  MenuItem,
  InputAdornment,
  IconButton,
  Grid,
  FormLabel,
  FormGroup,
  Tooltip,
  Button
} from '@mui/material';
import DataConfirmModal from "~common/components/data-confirm-modal";
import InputMask from "react-input-mask";
import { PredefinedField } from "~common/lib/types";
import { TextFieldProps } from "@mui/material/TextField";
import DateField from "~common/components/date-field";
import TimeField from "~common/components/time-field";
import NumberField from "~common/components/number-field";
import ChipField from "~common/components/chip-field";
import VersionedDocumentField from "~common/components/versioned-document-field";
import VersionedDocumentList from "~common/components/versioned-document-list";
import RelationField from "~common/components/relation-field";
import Autocomplete from "~common/components/autocomplete-field";
import RelationList from "~common/components/relation-list";
import RichTextEditor from "~common/components/rich-text-editor";
import DocumentList from "~common/components/document-list";
import ImageList from "~common/components/image-list";

import * as moment from "moment";
import * as accounting from "accounting";
import Autosuggest from "~common/components/autosuggest";
import classNames from "classnames";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AutoSuggest, { AutoSuggestQuery } from "~common/components/autosuggest";
import * as request from "superagent";
import { APIError } from "~common/lib/types";
import { getValueAtPath } from "~common/form/helper";

import Poptart from "~common/components/poptart";
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import CircularProgress from '@mui/material/CircularProgress';
// import VerifiedIcon from '@mui/icons-material/Verified';
// import NewReleasesIcon from '@mui/icons-material/NewReleases';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import GppGoodIcon from '@mui/icons-material/GppGood';
import GppBadIcon from '@mui/icons-material/GppBad';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { withWidth } from "@mui/material";



const styles = (theme: Theme): StyleRules => ({
  formDefField: {
    width: "calc(100% - 16px)"
  },
  formDefFieldWarn: {
    width: "100%",
    "& div": {
      "&::after": {
        border: "1px solid #ffe002 !important",
        transform: "scaleX(1)",
      },
    },
  },
  validationButtonRequired: {
    color: '#9c3030',
    width: "26px",
    height: "26px",
    marginBottom: '2px',
  },
  validationButtonError: {
    color: '#f44336',
    width: "26px",
    height: "26px",
    marginBottom: '2px',
  },
  validationButtonOptional: {
    color: "#294d6a",
    width: "26px",
    height: "26px",
    marginBottom: '2px',
  },
  validationOnlyButton: {
    marginTop: 15,
  },
  validationOnlyButtonDisplay: {
    marginTop: 15,
    // display: "none",
    '&:hover': {
      cursor: 'default',
      backgroundColor: "transparent",
      borderColor: theme.components.MuiButton?.defaultProps.outlinedPrimary.borderColor,
    }
  },
  '@keyframes flicker': {
    from: {
      opacity: 1,
    },
    to: {
      opacity: 0.3,
    },
  },
  flicker: {
    animationName: '$flicker',
    animationDuration: '1000ms',
    animationIterationCount: 'infinite',
    animationDirection: 'alternate',
    animationTimingFunction: 'ease-in-out',
  },
  withAnimation: ({ disabled }: { disabled: boolean }) => ({
    animationPlayState: disabled ? 'paused' : 'running',
  }),
  formDefFieldHistory: {
    width: "100%",
    "& div": {
      "&::after": {
        border: "1px solid #1614b3 !important",
        transform: "scaleX(1)",
      },
    },
  },
  checkBoxRequired: {
    width: "100%",
    "& .check-required": {
      "& .MuiFormControlLabel-label::after": {
        color: "red",
        content: `'*'`,
        // "&::after": {
        //   content: "*",
        //   color: "red",
        //   fontWieght: 600,
        //   fontSize: "0.85rem"
        // },
      },
    },
  },
  chip: {
    margin: `${theme.spacing()}px ${theme.spacing() / 4}px`,
  },
  compactLabel: {
    fontSize: '0.75rem'
  },
  invisibleChip: {
    display: 'none'
  },
  blankFormLine: {
    paddingTop: "0px !important",
    paddingBottom: "0px !important",
    paddingLeft: "30px !important",
    // padding: "0px, 0px, 0px, 15px !important",
    margin: 0,
  },
  rangeFieldFrom: {
    marginLeft: 3,
  },
  rangeFieldTo: {
    marginLeft: 3,
  },
  displayText: {
    marginTop: 16,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  questionField: {
    width: "30%",
    margin: "5px",
    alignItems: "baseline",
  },
  questionLabel: {
    fontSize: ".85rem",
    width: "70%",
    margin: "5px",
    alignItems: "baseline",
  },
  required: {
    color: "red",
    fontWieght: 600,
    fontSize: "0.85rem",
  },
  questionFlexbox: {
    display: "flex",
    width: "100%",
    alignItems: "baseline",
    flexGrow: 1,
  },
  questionFlexError: {
    display: "flex",
    width: "98.5%",
    justifyContent: "flex-end",
  },
  portalUserOption: {
    fontSize: "1.05rem",
  },
  defaultMenuItem: {},
  errorMenuItem: {
    color: "red",
  },
  defaultAddressLabel: {},
  errorAddressLabel: {
    color: "#f44336",
  },
  
  importantMenuItem: {
    fontWeight: "bold",
  },
  autocomplete: {
    width: "100% !important", 
  }
});

// BEFORE YOU ADD PROPS HERE:  Please consider that this is a HELPER to use when building forms where the Primary considerations are the contents of the form definition
// Please consider whther adding a property here is really necessary, or wether it belongs as part of the form definition, itself, or whether you should really be using
// one of the underlying controls directly.
interface Props extends TextFieldProps {
  path: string;
  value: any | undefined;
  // all data
  data: any | undefined;
  fieldDefinition?: PredefinedField;
  errorText?: string;
  onChange?: (newVal: any) => void;
  onValidate?: (newVal: any) => Promise<any>;
  onCommitChange?: (newVal: any) => void;
  policyMessages?: Array<any>;
  shrink?: boolean;
  customRenderers?: any;
  showHidden?: boolean;
  nullPlaceholder?: string;
  readOnly?: boolean;
  onFileReject?: (rejectedFiles: Array<any>) => void;
  onKeyDown?: any;
}

type State = {
  value?: any;
  displayValue?: any;
  open?: boolean;
  modalOpen?: boolean;
  showPassword: boolean;
  flattenRichText: boolean;
  customErrorMessage?: string;
  localWarning?: string;
  localLoading?: boolean
};

class FormDefField extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    var defVal: any;
    if (props.fieldDefinition) {
      defVal = props.fieldDefinition.defaultValue;
    }

    let newValue = props.value || defVal;
    let fieldValue: any = this.mapFieldValue(newValue);

    this.state = {
      value: newValue,
      displayValue: fieldValue,
      showPassword: false,
      flattenRichText: true,
    };

    if (props.value != newValue) {
      if (this.props.onCommitChange) {
        this.props.onCommitChange(newValue);
      }
    }
  }

  UNSAFE_componentWillReceiveProps(
    newProps: Props & WithStyles<keyof typeof styles>
  ) {
    let defVal = "";
    if (newProps.fieldDefinition) {
      defVal = newProps.fieldDefinition.defaultValue;
    }

    let fieldValue: any = this.mapFieldValue(newProps.value || defVal);
    this.setState({
      value: newProps.value,
      displayValue: fieldValue,
    });
  }

  isKeypressCharValid = (e, chars) => {
    e = e || window.event;

    // Allow delete, tab, enter and escape keys through
    if (/^(8|9|13|27)$/.test("" + e.charCode)) {
      return true;
    }

    var charCode = typeof e.which == "number" ? e.which : e.charCode;
    var charTyped = String.fromCharCode(charCode);
    return chars.indexOf(charTyped) > -1;
  };

  mapFieldValue = (v: any): any => {
    const { fieldDefinition, nullPlaceholder } = this.props;
    var np = "--";
    if (nullPlaceholder) {
      np = nullPlaceholder;
    }

    let def = "";
    if (v === null || v === undefined) {
      return np;
    }

    if (
      fieldDefinition &&
      fieldDefinition.options &&
      fieldDefinition.options.length > 0
    ) {
      for (let opt of fieldDefinition.options) {
        if (opt.value == v) {
          return opt.label;
        } else if (!opt.value) {
          def = opt.label;
        }
      }
    } else {
      if (fieldDefinition && fieldDefinition.mode == "Display") {
        switch (fieldDefinition.type) {
          case "Date":
            // Doesnt include time shifting, static UTC Date
            var val = moment.utc(v);

            if (val.isValid()) {
              def = val.format("MM/DD/YYYY");
            }
            

            break;

          case "Time":
            // Includes time shifting
            var val = moment(v);
            if (val.isValid()) {
              def = val.format("MM/DD/YYYY");
            }
            break;

          case "DateTime":
            def = moment(v).format("MM/DD/YYYY h:mm:ss a");
            break;

          case "Currency":
            // Display mode was not honoring precision and defaulting to 2 when null
            def = accounting.formatMoney(v, null, fieldDefinition.precision);
            break;

          case "PortalUser":
            if (v.firstName && v.lastName) {
              return `${v.firstName} ${v.lastName}`;
            }
            return "--";
          case "RichText":
            def = v.label;
            break;
          case "Relation":
            if (!v.value) {
              return null;
            }
          default:
            def = v.label;
        }
      }
    }

    // Always return self to make it safe
    return def || v || null;
  };

  onKeyPress = (e: any) => {
    const { fieldDefinition } = this.props;
    let valid = true;
    if (
      fieldDefinition &&
      fieldDefinition.allowedCharacters &&
      fieldDefinition.allowedCharacters.length > 0
    ) {
      valid = this.isKeypressCharValid(e, fieldDefinition.allowedCharacters);
    }

    if (!valid) {
      e.preventDefault();
    }

    return valid;
  };

  onPaste = (event: any) => {
    const { onChange, fieldDefinition } = this.props;
    const {value} = this.state
    if (fieldDefinition.allowedCharacters) {
      navigator.clipboard
        .readText()
        .then((text) => {
          var warn = null;
          var ok = true;
          text.split("").forEach(function (c) {
            if ((fieldDefinition.allowedCharacters).indexOf(c) == -1) {
              ok = false;
              warn  = "Invalid Character(s) detected in paste content";
            }
          });
          if (!ok) {
            this.setState({ value: value, localWarning: warn }, () => {
              if (onChange) {
                onChange(value);
              }
            });
          }
        })
        .catch((err) => {
          console.error("Failed to read clipboard contents: ", err);
        });
    }
  };

  onChange = (evt: any) => {
    const { onChange } = this.props;
    let value = this.state;

    value = evt.target.value;

    this.setState({localWarning:null, value: evt.target.value });

    if (onChange && this.props.value != value) {
      onChange(evt.target.value);
    }
  };

  onChipChange = (evt: any) => {
    const { onChange, onCommitChange } = this.props;
    
    let value = this.state;
    
    var sVal = String(value.value)
    var valPrefix = sVal.substring(0, sVal.lastIndexOf('|')+1);

    var newVal: any 
    if (evt.target) {
      newVal = valPrefix + evt.target.value;
    } else {
      newVal = evt
    }

    this.setState({ value: newVal });

    if (onChange && this.props.value != newVal) {
      onChange(newVal);
    }
    if (onCommitChange && this.props.value != newVal) {
      onCommitChange(newVal);
    }
  };

  onBooleanChange = (evt: any) => {
    const { onChange, onCommitChange } = this.props;
    let value = this.state;

    value = evt.target.checked;
    this.setState({ value });

    if (onChange && this.props.value != value) {
      onChange(value);
    }
    if (onCommitChange && this.props.value != value) {
      onCommitChange(value);
    }
  };

  onAutoSuggestChange = (evt: any, stuff: any) => {};

  onSelectChange = (evt: any) => {
    const { onChange, onCommitChange } = this.props;
    let { value } = this.state;

    if (value != evt.target.value) {
      const origVal = evt.target.value;
      let newVal = evt.target.value;
      if (newVal == "_nullOption") {
        newVal = null;
      }

      value = origVal;
      this.setState({ value });

      if (onChange && this.props.value != newVal) {
        onChange(newVal);
      }

      if (onCommitChange && this.props.value != newVal) {
        onCommitChange(newVal);
      }
    }
  };

  onRelationSelectChange = (evt: any) => {
    const { onChange, onCommitChange, fieldDefinition } = this.props;
    let { value } = this.state;

    const origVal = evt.target.value;
    let newVal = evt.target.value;
    if (newVal == "_nullOption") {
      newVal = null;
    }

    // Selects don't like having objects as values, so we are using the label then finding the object.
    if (
      fieldDefinition &&
      fieldDefinition.options &&
      fieldDefinition.options.length > 0
    ) {
      value = fieldDefinition.options.find((v) => {
        return v.label == origVal || v.value == newVal;
      });

      this.setState({ value });

      if (onChange) {
        onChange(value);
      }

      if (onCommitChange) {
        onCommitChange(value);
      }
    } else {
      console.error("Unexpected field def missing");
    }
  };

  onDateChange = (value: any) => {
    const { onChange, onCommitChange } = this.props;

    // Convert to a javascript date if it is a moment date
    if (value && value.toDate) {
      value = value.toDate();
    }
    this.setState({
      value: value,
    });
    if (onChange && this.props.value != value) {
      onChange(value);
    }

    if (onCommitChange && this.props.value != value) {
      onCommitChange(value);
    }
  };

  onCommitChange = (evt: any) => {
    let { value } = this.state;
    const { onCommitChange } = this.props;

    value = evt.target.value;
    this.setState({ value });

    if (onCommitChange && this.props.value != this.state.value) {
      onCommitChange(value);
    }
  };



  onRichTextCommitChange = (evt: any) => {
    let { value, flattenRichText } = this.state;
    const { onCommitChange } = this.props;
    if (!value) {
      value = {};
    }

    if (flattenRichText) {
      value = evt.target.value;
    } else {
      value.html = evt.target.value;
    }
    this.setState({ value });

    if (onCommitChange && this.props.value != this.state.value) {
      onCommitChange(value);
    }
  };

  handleClickShowPasssword = () => {
    var { showPassword } = this.state;
    this.setState({
      showPassword: !showPassword,
    });
  };

  onTextFieldClick = (evt: any) => {
    // allows field info icon to be clicked. 
    if (evt.target.classList.contains('form-def-field-info')) {
      evt.stopPropagation()
    }
  }


  // handleClickValidation = () => {
  //   const { onValidate, fieldDefinition } = this.props;
  //   // this.setState({ localLoading:true })
  //   if (onValidate ) {
  //     onValidate(fieldDefinition.key)
  //   }
  //   // this.setState({ localLoading:false })

  // };

  handleClickValidation = () => {
    // If onBeforeSubmit<Promise> is not null, execute first and continue based on return
    const { fieldDefinition, path } = this.props;
    if (this.props.onValidate) {
      this.setState({ localLoading:true })
      this.props
        .onValidate(fieldDefinition.key, path, false)
        .then((response) => {
          if (response) {
            var respArray = response as Array<string>
            if (respArray.length > 0) {
              // Add possible check to ignore info messages?
              this.setState({ localLoading:false, modalOpen: false})
            } else {
              this.setState({ localLoading:false, modalOpen: true})
            }
          } else {
            this.setState({ localLoading:false, modalOpen: true})
          }
          
        })
        .catch((err) => {
          this.setState({
            localLoading:false,
          });
        });
    } else {
      this.setState({ localLoading:false })
    }
  };

  handleNullClick = () => {
    // If onBeforeSubmit<Promise> is not null, execute first and continue based on return
    return
  };



  onNewDirectChange = (suppressCommit?: Boolean) => (value: any) => {
    const { onCommitChange, onChange } = this.props;

    if (onChange ) {
      onChange(value);
    }

    this.setState({ value });
    if (onCommitChange && !suppressCommit) {
      onCommitChange(value);
    }
  };

  onDirectChange = (suppressCommit?: Boolean) => (value: any) => {
    const { onCommitChange } = this.props;

    this.setState({ value });

    if (onCommitChange && !suppressCommit) {
      onCommitChange(value);
    }
  };

  onNumericRangeChange = (attr: any, val: any) => {
    const { onCommitChange } = this.props;

    var { value } = this.state;
    if (!value) {
      value = {};
    }
    value[attr] = val;
    this.setState({ value }, () => {
      if (onCommitChange) {
        onCommitChange(value);
      }
    });
  };

  onDateRangeChange = (attr: any, val: any) => {
    const { onCommitChange } = this.props;

    let errorMsg = null;

    if (val && val.toDate) {
      val = val.toDate();
    }

    this.setState({
      value: val || "",
      displayValue: null,
      customErrorMessage: errorMsg,
    });

    var { value } = this.state;
    if (!value) {
      value = {};
    }

    value[attr] = val;
    this.setState({ value }, () => {
      if (onCommitChange) {
        onCommitChange(value);
      }
    });
  };

  onAddressChange = (attr: any, evt: any) => {
    var { value } = this.state;
    if (!value) {
      value = {};
    }
    let newVal = evt.target.value;
    if (newVal == "_nullOption") {
      newVal = null;
    }
    value[attr] = newVal;
    this.setState({ value });
  };

  onAddressStateAutocompleteChange = (evt: any) => {
    var { value } = this.state;
    if (!value) {
      value = {};
    }
    let newVal = evt
    if (newVal == "_nullOption") {
      newVal = null;
    }
    value["state"] = newVal;
    const cb = this.onAdadaddressCommitChange
    this.setState({ value }, ()=>{
      var evt = {target: {value: newVal}}
      cb("state",evt )
    });
  };

  onAdadaddressCommitChange = (attr: any, evt: any) => {
    const { onCommitChange } = this.props;
    var { value } = this.state;
    if (!value) {
      value = {};
    }
    value[attr] = evt.target.value;
    this.setState({ value }, () => {
      if (onCommitChange) {
        onCommitChange(value);
      }
    });
  };

  getTextFieldType = (fd: PredefinedField) => {
    if (!fd.variant || fd.variant == "") {
      return "text";
    }

    if (fd.variant == "Password" && !this.state.showPassword) {
      return "password";
    }


    return "text";
  };

  renderSuggestionContent = (suggestion: any) => {
    const { classes }: { classes: ClassNameMap } = this.props;
    return (
      <Grid container spacing={0}>
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <FormControl className={formDefClass}>
            <InputLabel shrink>First</InputLabel>
            <div className={classes.displayText}>{suggestion.firstName}</div>
          </FormControl>
        </Grid>

        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
          <FormControl className={formDefClass}>
            <InputLabel shrink>MI</InputLabel>
            <div className={classes.displayText}>
              {suggestion.middleInitial || "--"}
            </div>
          </FormControl>
        </Grid>

        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <FormControl className={formDefClass}>
            <InputLabel shrink>Last</InputLabel>
            <div className={classes.displayText}>{suggestion.lastName}</div>
          </FormControl>
        </Grid>

        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
          <FormControl className={formDefClass}>
            <InputLabel shrink>Employee ID</InputLabel>
            <div className={classes.displayText}>
              {suggestion.employeeID || "--"}
            </div>
          </FormControl>
        </Grid>
      </Grid>
    );
  };

  closeValidation = () => {
    this.setState({ modalOpen: false});
  };


  denyValidation = () => {
    const { fieldDefinition, path } = this.props;
    this.props
        .onValidate(fieldDefinition.key, path, true)
        .then((response) => {
          this.setState({ localLoading:false, modalOpen: false})
        })
  };

  renderValidationAdornment = (error: boolean, validationOnly?: boolean, helperText?: string) => {
    const { classes }: { classes: ClassNameMap } = this.props;
    const { onAccessRootData, fieldDefinition, path } = this.props;
    var { localLoading, modalOpen } = this.state;
    var disabled = false
    var validationStatus = ""
    var validationColor="inherit"
    var validationAttemps = 0
    var toolTipText = 'Click to verify data'
    if (fieldDefinition.validationAttributes.mode == "Required") {
      toolTipText = 'Verification required'
    }

    if (fieldDefinition.validationAttributes.tooltipText) {
      toolTipText = fieldDefinition.validationAttributes.tooltipText
    }

    var buttonColor="inherit"
    // var buttonColor = "primary"
    if (disabled) {
      buttonColor = ""
    }
    var buttonClass = classes.validationButtonOptional
    if (fieldDefinition.validationAttributes.mode == "Required") {
      buttonClass  = classes.validationButtonRequired
    }
  
    if (fieldDefinition.validationAttributes.validationDataPath) {
      var pathString = fieldDefinition.validationAttributes.validationDataPath

      var regex = /(\d+)/;
      var match = path.match(regex);

      if (match) {
        pathString = pathString.replace('/*/', '/'+match[1]+'/')
      }

      if (onAccessRootData){
        var validationData = onAccessRootData(pathString)

        
        if (validationData) {
          validationAttemps = validationData.attempts
          validationStatus = validationData.status 
        }

        
        // Disables button if max attempts has been met
        if (fieldDefinition.validationAttributes.maxAttempts != 0 && fieldDefinition.validationAttributes.maxAttempts <= validationAttemps) {
          disabled = true
          toolTipText = 'Max attempts exceeded'
        }

        // Changes the color and Icon based on these switches
        
        switch (validationStatus) {
          case "Success":
            break
          case "Failure":
            break
          case "Warn":
            break
          default:
            validationStatus = ""
            
        }

        // Checks if the data has changed
        var dataHasChanged = false
        if (validationData && validationData.evaluatedData) {
            Object.entries(validationData.evaluatedData).forEach(entry => {
              const [key, value] = entry;
              let compValue = onAccessRootData(key)
              if (!_.isEqual(value, compValue)) {
                dataHasChanged = true
              }
            });
        }

        // Resets the button to non-validated if the data has changed since the last request.
        // However button status should not change if re-submission is allowed
        if (dataHasChanged && !fieldDefinition.validationAttributes.allowResubmission) {

          validationStatus = ""
          
        }

        // Disables button if a non-indeterminate status is recorded and the data has not changed
        // AKA Disallows re submitting data when it hasn't changed. 
        if (!fieldDefinition.validationAttributes.allowResubmission && (validationStatus == "Success" || validationStatus == "Failure" || validationStatus == "Warn")) {
          
          disabled = !dataHasChanged
          if (disabled) {
            if (validationStatus == "Success") {
              toolTipText = 'Data already verified!'
            } else {
              toolTipText = 'Relevant data has not changed since last attempt'
            }
            
          } else {
            toolTipText = 'Previous attempt invalidated'
          } 
        }
      }
    }

    var confirmDialogMessage = "Confirm Data"
    if (fieldDefinition.validationAttributes.dialogTitle) {
      confirmDialogMessage = fieldDefinition.validationAttributes.dialogTitle
    }
    
    var confirmValidationModal = null
    if (fieldDefinition.validationAttributes.requireConfirmation && fieldDefinition.validationAttributes.dialogFormSelector != {} && fieldDefinition.validationAttributes.undoValidationURL != "") {
      confirmValidationModal = (
        <DataConfirmModal
          terminal={true}
          open={modalOpen}
          validationOptions={fieldDefinition.validationAttributes}
          validationData={validationData}
          confirmationMessage={confirmDialogMessage}
          onClose={this.closeValidation}
          onDeny={this.denyValidation}
        />
      );
    }
    

    if(validationOnly) {

      if(!fieldDefinition.validationAttributes.buttonText){
        fieldDefinition.validationAttributes.buttonText = 'Verify' 
      }

      var variant = "outlined"
      var voIcon = <HelpOutlineIcon  />
      if(fieldDefinition.validationAttributes.mode == "Required"){
          variant = "contained"
          voIcon = <ErrorOutlineIcon  />
      } 

      // if (toolTipText == "Data already verified!") {
      //   voIcon = <GppGoodIcon/>
        
      // }

      var altButtonText = ""
      switch(validationStatus){
        case "Success":
          validationColor = 'success'
          altButtonText = "Verified"
          voIcon = <GppGoodIcon/>
          break
        case "Failure":
          validationColor = 'error'
          altButtonText = "Failed"
          voIcon = <GppBadIcon/>
          break
        case "Warn":
          validationColor = 'secondary'
          altButtonText = "Warning"
          voIcon = <GppMaybeIcon/>
          break
        default:
          validationColor = 'secondary'
      }

      if (altButtonText != "" && fieldDefinition.validationAttributes.showStatusAsButtonText) {
        fieldDefinition.validationAttributes.buttonText = altButtonText
      }
      var buttonClass = classes.validationOnlyButton
      var onClick = this.handleClickValidation
      if (fieldDefinition.validationAttributes.mode == "Display") {
        buttonClass = classes.validationOnlyButtonDisplay
        onClick = this.handleNullClick
      }



      return (
        <Tooltip title={fieldDefinition.validationAttributes.mode != "Display" && toolTipText}>
        <div style={fieldDefinition.styleAttributes}>
          {confirmValidationModal}
          <FormControl
                error={error}
                style={{ display: "list-item", listStyle: "none" }}
                className={classes.checkBoxRequired}
                component="fieldset"
              >
                <Button 
                  size="small" 
                  variant={variant} 
                  startIcon={voIcon} 
                  color={validationColor} 
                  disabled={disabled || localLoading || fieldDefinition.validationAttributes.mode == "Read Only"} 
                  className={buttonClass} 
                  tabIndex={-1} 
                  onClick={onClick}>
                    {fieldDefinition.validationAttributes.buttonText} 
                  </Button>
                {helperText && <FormHelperText>{helperText}</FormHelperText>}
              </FormControl>
            
        </div>
        </Tooltip>
      )

    } else {

      var errorClass = null
      if (error) {
        errorClass = `${classes.flicker} ${classes.withAnimation}`
        if (fieldDefinition.validationAttributes.mode == "Required") {
          buttonClass = classes.validationButtonError
        }
        
      }

      if (fieldDefinition.validationAttributes.mode != "Hidden"){
        return (
          <InputAdornment position="end">
            
            {confirmValidationModal}
            {validationStatus=="Success" && <GppGoodIcon color={'success'} />}
            {validationStatus=="Failure" && <GppBadIcon color={'error'} />}
      
            <Tooltip title={toolTipText}>
              <span>
              <IconButton size="small" sx={{ boxShadow: 1 }} disabled={disabled || localLoading || fieldDefinition.validationAttributes.mode == "Read Only"} tabIndex={-1} className={buttonClass}  onClick={this.handleClickValidation}>
              
  
              {localLoading && <i className="fa fa-spinner fa-spin" />}
              {!localLoading && fieldDefinition.validationAttributes.mode == "Required" && <ErrorOutlineIcon className={errorClass} />}
              {!localLoading && (fieldDefinition.validationAttributes.mode != "Required") && <HelpOutlineIcon  />}
  
              </IconButton>
  
              </span>
            </Tooltip>
  
          </InputAdornment>
        );
      } else {
        return null
      }
      
    }
  }

  fetchPortalUserSuggestions = (query: AutoSuggestQuery): Promise<any> => {
    var { fieldDefinition } = this.props;
    var url = "/api/portal-user-field/search";
    if (fieldDefinition.portalUserFieldFulfillmentURL) {
      url = fieldDefinition.portalUserFieldFulfillmentURL;
    }
    return new Promise((resolve, reject) => {
      request
        .get(`${url}?term=${query.value}`)
        .then((response: request.Response) => {
          if (response.body.results && response.body.results.length > 0) {
            resolve(
              response.body.results.map((i: any) => {
                return {
                  label: `${i.firstName} ${i.lastName} (${i.userName})`,
                  value: i,
                  menuContent: this.renderSuggestionContent(i),
                };
              })
            );
          } else {
            resolve([]);
          }
        })
        .catch((err: any) => {
          const apiErr = new APIError();
          apiErr.type = "http";
          apiErr.message = "Error fetching data";
          apiErr.details = (err.response || { text: err.toString() }).text;
          reject(apiErr);
        });
    });
  };

  onPortalUserSelect = (attr: any, e: any) => (event: any, data: any) => {
    var { onCommitChange } = this.props;

    if (
      data &&
      data.suggestionValue &&
      Object.keys(data.suggestionValue || {}).length > 0
    ) {
      this.setState({ value: data.suggestionValue.value }, () => {
        if (onCommitChange) {
          onCommitChange(data.suggestionValue.value);
        }
      });
    } else {
      if (data.suggestionValue) {
        this.setState({});
      }
    }
  };

  getPortalUserValue = () => {
    var { value } = this.state;
    if (!value) {
      return "";
    } else {
      return `${value.firstName} ${value.lastName}`;
    }
  };

  filterConditionalOptions = (options: Array<any>): Array<any> => {
    var { onAccessRootData } = this.props;
    var { data } = this.props;

    options = options.filter((o: any) => {
      if (!o.conditions || o.conditions.length == 0) {
        return o;
      }
      if (o.conditions && o.conditions.length > 0) {
        var visible = false;

        o.conditions.forEach((c: any) => {
          if (c.path.indexOf("~") != 0) {
            // Does not equal
            if (String(c.value).startsWith("!")) {
              var evalValue = String(c.value).substring(1)
              if (String(getValueAtPath(c.path, data || {})) != evalValue) {
                visible = true;
              }
            // Equals
            } else {
              if (getValueAtPath(c.path, data || {}) == c.value) {
                visible = true;
              }
            }
            
          } else {
            if (onAccessRootData) {
              // Does not equal
              if (String(c.value).startsWith("!")) {
                var evalValue = String(c.value).substring(1)
                if (String(onAccessRootData(c.path)) != evalValue) {
                  visible = true;
                }
              // Equals
              } else {
                if (onAccessRootData(c.path) == c.value) {
                  visible = true;
                }
              }

            }
          }
        });
        if (visible) {
          return o;
        }
      }
    });
    return options;
  };

  onCheckboxOptionChange = (checkVal: string, event: any) => {
    var { value } = this.state;
    var vals = [];

    if (
      this.props.fieldDefinition &&
      this.props.fieldDefinition.variant == "Radio"
    ) {
      if (event.target.checked) {
        vals.push(checkVal);
      }
    } else {
      if (value && value.split) {
        vals = value.split("|");
      }

      if (event.target.checked) {
        vals.push(checkVal);
      } else {
        vals = vals.filter((v) => {
          return v != checkVal;
        });
      }
    }
    if (this.props.onCommitChange) {
      this.props.onCommitChange(vals.join("|"));
    }
  };

  checkedValue = (checkVal: string): boolean => {
    if (this.state.value && this.state.value.indexOf(checkVal) > -1) {
      return true;
    }
    return false;
  };

  renderStateField = (fd: any, fieldValue: any, formDefClass: any, helperText: any, invalidState: any, styleObj: any, labelStyleObj: any, shrink: any, nullOptionLabel: any, invalidStateMessage: any) => {
    const { classes }: { classes: ClassNameMap } = this.props;
    var autofillString =
      navigator.userAgent.indexOf("Chrome") > -1 ? "chrome-off" : "off";
    if (fd.addressAttributes && fd.addressAttributes.state && fd.addressAttributes.state.autoSuggestURL) {
      if (!fd.addressAttributes.state.mode) {
        fd.addressAttributes.state.mode = fd.mode
      }
      return (
        <Autocomplete
         title={
           (fd.addressAttributes &&
             fd.addressAttributes.state &&
             fd.addressAttributes.state.label) ||
           "State"
         }
         type={"Autocomplete"}
         className={classNames(formDefClass, classes.autocomplete)}
         mode={(fd.addressAttributes && fd.addressAttributes.state && fd.addressAttributes.state.mode) ?  fd.addressAttributes.state.mode : fd.mode}
         error={invalidState}
         shrink={shrink}
         fieldDefinition={fd.addressAttributes.state}
         helperText={invalidState ? invalidStateMessage : false}
         classes={{}}
         value={fieldValue ? fieldValue["state"] : ""}
         onDirectUpdate={this.onAddressStateAutocompleteChange}
         autoSuggestURL={fd.addressAttributes.state.autoSuggestURL}
         disabled={
          fd.mode == "Read Only" ||
          (fd.addressAttributes &&
            fd.addressAttributes.state &&
            fd.addressAttributes.state.mode &&
            fd.addressAttributes.state.mode == "Read Only") ||
          this.props.readOnly
        }
       ></Autocomplete>
      )
    } else if (fd.options && fd.options.length > 0) {
      return (
              <FormControl
                  disabled={
                    fd.mode == "Read Only" ||
                    (fd.addressAttributes &&
                      fd.addressAttributes.state &&
                      fd.addressAttributes.state.mode &&
                      fd.addressAttributes.state.mode == "Read Only") ||
                    this.props.readOnly
                  }
                  className={formDefClass}
                  style={styleObj}
                >
                  <InputLabel
                    error={invalidState}
                    style={labelStyleObj}
                    required={
                      fd.mode == "Required" &&
                      (!fd.addressAttributes ||
                        !fd.addressAttributes.state ||
                        !fd.addressAttributes.state.mode ||
                        fd.addressAttributes.state.mode == "Required")
                    }
                    htmlFor="select"
                  >
                    State
                  </InputLabel>
                  <Select
                    // id={fd.key + 'State'}
                    name={fd.key + "State"}
                    // open={this.state.open}
                    error={invalidState}
                    value={fieldValue ? fieldValue["state"] : ""}
                    onChange={this.onAddressChange.bind(this, "state")}
                    disabled={fd.mode == "Read Only" || this.props.readOnly}
                    onKeyPress={(event: any) => {
                      var keyPress = event.key;
                      var listID: string = "";
                      (fd.options || []).map((o: any, i: number) => {
                        if (
                          listID === "" &&
                          o.label.toLowerCase().charAt(0) ==
                            keyPress.toLowerCase()
                        ) {
                          listID = fd.key + "_" + i;
                          if (document.getElementById(listID) != null) {
                            const el = document.getElementById(listID);
                            if (el) {
                              el.scrollIntoView({ behavior: "smooth" });
                            }
                          }
                        }
                      });
                      this.setState({ open: true });
                    }}
                  >
                    {fd.mode != "Required" && !fd.defaultValue && (
                      <MenuItem value="_nullOption">{nullOptionLabel}</MenuItem>
                    )}
                    {fd.options.map((c: any, idx: number) => {
                      return (
                        <MenuItem
                          // id={fd.key + '_' + idx}
                          key={idx}
                          value={c.value}
                        >
                          {c.label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {invalidState && (
                    <FormHelperText error={invalidState}>
                      {helperText}
                    </FormHelperText>
                  )}
                </FormControl>
      )
    } else {
      return (
              <TextField
                  type={this.getTextFieldType(fd)}
                  required={
                    fd.mode == "Required" &&
                    (!fd.addressAttributes ||
                      !fd.addressAttributes.state ||
                      !fd.addressAttributes.state.mode ||
                      fd.addressAttributes.state.mode == "Required")
                  }
                  // id={fd.key + 'State'}
                  name={fd.key + "State"}
                  value={fieldValue ? fieldValue["state"] : ""}
                  label={
                    (fd.addressAttributes &&
                      fd.addressAttributes.state &&
                      fd.addressAttributes.state.label) ||
                    "State"
                  }
                  className={formDefClass}
                  onChange={this.onAddressChange.bind(this, "state")}
                  inputProps={{
                    autoComplete: autofillString,
                  }}
                  InputLabelProps={{
                    style: labelStyleObj,
                    shrink:
                      shrink !== false || (value != null && value.length > 0),
                  }}
                  onBlur={this.onAdadaddressCommitChange.bind(this, "state")}
                  error={invalidState}
                  helperText={invalidState ? invalidStateMessage : false}
                  disabled={
                    fd.mode == "Read Only" ||
                    (fd.addressAttributes &&
                      fd.addressAttributes.state &&
                      fd.addressAttributes.state.mode &&
                      fd.addressAttributes.state.mode == "Read Only") ||
                    this.props.readOnly
                  }
                />
      )
    }
  }

  render() {
    const { classes }: { classes: ClassNameMap } = this.props;
    const {
      fieldDefinition,
      errorText,
      shrink,
      policyMessages,
      onAccessRootData,
      path,
      showHidden,
      data
    } = this.props;
    const { value, displayValue, flattenRichText, localWarning, localLoading } = this.state;

    var invalidAddressHeader = false;
    var invalidAddressHeaderMessage = "";
    var invalidAddress1 = false;
    var invalidAddress1Message = "";
    var invalidAddress2 = false;
    var invalidAddress2Message = "";
    var invalidAddress3 = false;
    var invalidAddress3Message = "";
    var invalidCity = false;
    var invalidCityMessage = "";
    var invalidCounty = false;
    var invalidCountyMessage = "";
    var invalidState = false;
    var invalidStateMessage = "";
    var invalidPostalCode = false;
    var invalidPostalCodeMessage = "";
    var invalidCountry = false;
    var invalidCountryMessage = "";

    var addressMessageClass = classes.defaultAddressLabel
    

    var formDefClass = classes.formDefField;

    var fieldValue = "";
    if(value !== null && value !== undefined) {
      fieldValue = value;
    }

    let errorTextVal = errorText;

    // Should never happen, but is possible in lazy loading scenarios, so to protect.
    if (!fieldDefinition) {
      return null;
    }

    let fd: PredefinedField = fieldDefinition;

    // Bail if we do not have
    if (!fd) {
      console.warn("Field definition cannot be null, hiding field");
      return null;
    }

    const nullOptionLabel = fd.nullOptionLabel || "";
    var validationError = false

    let helperText = fd.helpText;
    if (localWarning) {
      helperText = localWarning;
    }

    // See if we need to handle policy violations
    if (policyMessages) {
      policyMessages.sort((a, b) => {
        return b.severity - a.severity;
      });

      const applicable = policyMessages.reduce((acc, m): Array<any> => {
        let mp = m.path;
        if (mp.indexOf("/") == 0) {
          mp = mp.substring(1);
        }

        let op = path;
        if (op.indexOf("/") == 0) {
          op = op.substring(1);
        }
        if (mp == op) {
          acc.push(m);
        }

        return acc;
      }, []);

      if (applicable.length > 0) {
        var errorMessage = applicable[0].title;
        if (fd.type == "Address") {
          if (
            applicable[0].extendedAttributes &&
            applicable[0].extendedAttributes.fields
          ) {
            invalidAddress1 = applicable[0].extendedAttributes.fields.find(
              (m: any) => {
                if (m["address1"] != undefined) {
                  invalidAddress1Message = m["address1"];
                  return true;
                } else {
                  return false;
                }
              }
            )
              ? true
              : false;
            invalidAddress2 = applicable[0].extendedAttributes.fields.find(
              (m: any) => {
                if (m["address2"] != undefined) {
                  invalidAddress2Message = m["address2"];
                  return true;
                } else {
                  return false;
                }
              }
            )
              ? true
              : false;
            invalidAddress3 = applicable[0].extendedAttributes.fields.find(
              (m: any) => {
                if (m["address3"] != undefined) {
                  invalidAddress3Message = m["address3"];
                  return true;
                } else {
                  return false;
                }
              }
            )
              ? true
              : false;
            invalidCity = applicable[0].extendedAttributes.fields.find(
              (m: any) => {
                if (m["city"] != undefined) {
                  invalidCityMessage = m["city"];
                  return true;
                } else {
                  return false;
                }
              }
            )
              ? true
              : false;
              invalidCounty = applicable[0].extendedAttributes.fields.find(
                (m: any) => {
                  if (m["county"] != undefined) {
                    invalidCountyMessage = m["county"];
                    return true;
                  } else {
                    return false;
                  }
                }
              )
                ? true
                : false;
            invalidState = applicable[0].extendedAttributes.fields.find(
              (m: any) => {
                if (m["state"] != undefined) {
                  invalidStateMessage = m["state"];
                  return true;
                } else {
                  return false;
                }
              }
            )
              ? true
              : false;
            invalidPostalCode = applicable[0].extendedAttributes.fields.find(
              (m: any) => {
                if (m["postalCode"] != undefined) {
                  invalidPostalCodeMessage = m["postalCode"];
                  return true;
                } else {
                  return false;
                }
              }
            )
              ? true
              : false;
            invalidCountry = applicable[0].extendedAttributes.fields.find(
              (m: any) => {
                if (m["country"] != undefined) {
                  invalidCountryMessage = m["country"];
                  return true;
                } else {
                  return false;
                }
              }
            )
              ? true
              : false;
          } else {
            invalidAddressHeader = true
            invalidAddressHeaderMessage = applicable[0].title;

            
          }
        } 
        if (applicable[0].severity == 2) {
          errorTextVal = applicable[0].title;
          addressMessageClass = classes.errorAddressLabel
        } else if (applicable[0].severity == 1) {
          formDefClass = classes.formDefFieldWarn;
          helperText = errorMessage;
        } else if (applicable[0].severity == 4) {
          formDefClass = classes.formDefFieldHistory;
          helperText = errorMessage;
        } else {
          helperText = errorMessage;
        }

        if (applicable[0].extendedAttributes && applicable[0].extendedAttributes.validationError) {
          validationError = true
        }
      }

    }
    

    errorTextVal = errorTextVal || this.state.customErrorMessage;

    let error: boolean = false;
    if (errorTextVal) {
      if (errorTextVal.length > 0) {
        error = true;
        helperText = errorTextVal;
      }
    }

    if (fd.mode == "Hidden" && !showHidden) {
      return null;
    }

    var autofillString =
      navigator.userAgent.indexOf("Chrome") > -1 ? "chrome-off" : "off";

    // If there are options, set the field value to the mapping of the options.
    const styleObj = fd.styleAttributes;
    const labelStyleObj = fd.labelStyleAttributes;

    var fieldLabel = (
      <InputLabel
        error={error}
        style={labelStyleObj}
        shrink={shrink !== false || (value != null && value.length > 0)}
        required={fd.mode === "Required"}
        htmlFor="select"
      >
        {
          <span>
            {fd.title}
            {fd.mode == "Key Field" && (
              <i
                style={{ color: "#CD5C5C", marginLeft: 5 }}
                className="fa fa-key"
              ></i>
            )}
          </span>
        }
      </InputLabel>
    );

    if (fd.fieldInfo && fd.fieldInfo.content) {
      fieldLabel = (
        <InputLabel
          required={fd.mode === "Required"}
          style={labelStyleObj}
          shrink
        >
          {fd.title}
          <div style={{ display: "inline-block" }}>
            <Poptart
              click={true}
              className="form-def-field-info"
              placement={fd.fieldInfo.popperPlacement || "top"}
              icon={`fa ${fd.fieldInfo.icon || "fa-question-circle"}`}
              error={error}
              timeout={350}
              iconStyle={{
                display: "inline-block",
                marginLeft: 5,
              }}
            >
              <div
                style={{ width: fd.fieldInfo.popperWidth, padding: 5 }}
                dangerouslySetInnerHTML={{ __html: fd.fieldInfo.content }}
              ></div>
            </Poptart>
          </div>
        </InputLabel>
      );
    }

    //Check to see if the item has options.  If it does, we will always render a select, unless we are in display mode
    if (
      fd.allowOptionsFilter &&
      fd.options &&
      fd.options.length > 0 &&
      fd.mode != "Display"
    ) {
      switch (fd.type) {
        case "Text":
          return (
            <FormControl className={formDefClass} style={styleObj}>
              {/* <InputLabel
                error={error}
                shrink={shrink !== false || (value != null && value.length > 0)}
                required={fd.mode == 'Required'}
                htmlFor="select">
                {fd.title}
              </InputLabel> */}
              {fieldLabel}
              <Autosuggest
                name={fd.key}
                preventBusyTab={true}
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                staticOptions={fd.options}
                minQueryChars={fd.minQueryChars || 1}
                classes={{}}
                placeholder=""
                value={fieldValue || ""}
                // renderSuggestion={this.renderSuggestion}
                onSuggestionSelected={(attr: any, data: any) => {
                  if (data) {
                    this.onSelectChange({
                      target: { value: data.suggestionValue.value },
                    });
                  }
                }}
              />
            </FormControl>
          );

          break;
        case "ImageList":
          return (
            <ImageList
              policyMessages={policyMessages}
              path={path}
              definition={fd}
              data={fieldValue}
              hidePublicSelector={true}
              onImageListChange={this.onDirectChange(false)}
            />
          );
          break;
        case "Relation":
          return (
            <FormControl
              disabled={fd.mode == "Read Only" || this.props.readOnly}
              className={formDefClass}
              style={styleObj}
              error={error}
            >
              {/* <InputLabel
                error={error}
                shrink={shrink !== false || (value != null && value.length > 0)}
                required={fd.mode == 'Required'}
                htmlFor="select">
                {fd.title}
              </InputLabel> */}
              {fieldLabel}
              <Autosuggest
                // id={fd.key}
                preventBusyTab={true}
                name={fd.key}
                staticOptions={fd.options}
                minQueryChars={fd.minQueryChars || 1}
                classes={{}}
                placeholder=""
                value={fieldValue || ""}
                // renderSuggestion={this.renderSuggestion}
                onSuggestionSelected={(attr: any, data: any) => {
                  if (data) {
                    this.onSelectChange({
                      target: { value: data.suggestionValue.value },
                    });
                  }
                }}
                disabled={fd.mode == "Read Only" || this.props.readOnly}
              />
              {helperText && <FormHelperText>{helperText}</FormHelperText>}
            </FormControl>
          );

          break;
      }
    }

    if (
      !fd.allowOptionsFilter &&
      fd.options &&
      fd.options.length > 0 &&
      fd.mode != "Display"
    ) {
      switch (fd.type) {
        case "Text":
          var options = this.filterConditionalOptions(fd.options);
          if (fd.variant == "Checkbox" || fd.variant == "Radio") {
            var formLabel = (
              <FormLabel component="legend">
                {
                  <span>
                    {fd.title}
                    {fd.mode == "Key Field" && (
                      <i
                        style={{ color: "#CD5C5C", marginLeft: 5 }}
                        className="fa fa-key"
                      ></i>
                    )}
                  </span>
                }
              </FormLabel>
            );
            if (fd.mode == "Required") {
              formLabel = (
                <FormLabel component="legend">
                  {fd.title}
                  <span className={classes.required}>&nbsp;*</span>
                </FormLabel>
              );
            }
            return (
              <FormControl
                error={error}
                style={{ display: "list-item", listStyle: "none" }}
                component="fieldset"
              >
                {formLabel}
                <FormGroup style={{ display: "inline-block" }}>
                  <Grid container>
                    {options.map((o: any) => {
                      var cbAttr: any;
                      if (fd.checkboxGridAttributes) {
                        cbAttr = fd.checkboxGridAttributes;
                      } else {
                        cbAttr = {};
                      }
                      return (
                        <Grid
                          item
                          xs={cbAttr.xs || "auto"}
                          sm={cbAttr.sm || "auto"}
                          md={cbAttr.md || "auto"}
                          lg={cbAttr.lg || "auto"}
                          xl={cbAttr.xl || "auto"}
                        >
                          <FormControlLabel
                            key={o.value}
                            // style={{display:'table'}}
                            control={
                              this.props.fieldDefinition.variant == "Radio" ? (
                                <Radio
                                  //id={o.value}
                                  // style={{display:'table-cell'}}
                                  inputProps={{
                                    name: o.value,
                                    autoComplete: autofillString,
                                  }}
                                  checked={this.checkedValue(o.value)}
                                  onChange={this.onCheckboxOptionChange.bind(
                                    this,
                                    o.value
                                  )}
                                  value={o.value}
                                  color="primary"
                                  disabled={
                                    fd.mode == "Read Only" ||
                                    this.props.readOnly
                                  }
                                />
                              ) : (
                                <Checkbox
                                  //id={o.value}
                                  // style={{display:'table-cell'}}
                                  inputProps={{
                                    name: o.value,
                                    autoComplete: autofillString,
                                  }}
                                  checked={this.checkedValue(o.value)}
                                  onChange={this.onCheckboxOptionChange.bind(
                                    this,
                                    o.value
                                  )}
                                  value={o.value}
                                  color="primary"
                                  disabled={
                                    fd.mode == "Read Only" ||
                                    this.props.readOnly
                                  }
                                />
                              )
                            }
                            label={o.label}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                </FormGroup>

                {helperText && <FormHelperText>{helperText}</FormHelperText>}
              </FormControl>
            );
          }

          if (fd.variant == "Question") {
            let titleQuestion = (
              <div className={classes.questionLabel} dangerouslySetInnerHTML={{__html: fieldDefinition.title}}>
                
              </div>
            );

            if (fd.mode == "Required") {
              titleQuestion = (
                  <div className={classes.questionLabel} dangerouslySetInnerHTML={{__html: fieldDefinition.title + '<span style="color: red">&nbsp;*</span>'}}></div>
              );
            }

            return (
              <FormControl
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                className={classes.questionFlexbox}
              >
                <div className={classes.questionFlexbox}>
                  {titleQuestion}
                  <Autocomplete
                    title={fd.variant == "Question" ? null : fd.title}
                    onAccessRootData={onAccessRootData}
                    className={classNames(formDefClass, classes.autocomplete)}
                    type={"Text"}
                    mode={fd.mode}
                    data={data}
                    error={errorTextVal}
                    shrink={shrink}
                    fieldDefinition={fd}
                    helpText={helperText}
                    classes={{}}
                    value={fieldValue}
                    onDirectUpdate={this.onNewDirectChange(false)}
                    autoSuggestURL={fd.autoSuggestURL}
                    appendToQuery={fd.appendToQuery}
                    disabled={fd.mode == "Read Only" || this.props.readOnly}
                  ></Autocomplete>
                </div>
              </FormControl>
            );
          }

          const nullOptionLabel = fd.nullOptionLabel || "";
          if (value == null) {
            fieldValue = "_nullOption";
          }

          // Regular SelectBox here
          return (
            <FormControl
              disabled={fd.mode == "Read Only" || this.props.readOnly}
              className={formDefClass}
              style={styleObj}
            >
              {/* <InputLabel
                error={error}
                shrink={shrink !== false || (value != null && value.length > 0)}
                required={fd.mode === 'Required'}
                htmlFor="select">
                {fd.title}
              </InputLabel> */}
              {fieldLabel}
              <Select
                //id={fd.key}
                name={fd.key}
                open={this.state.open}
                autoFocus={fd.autoFocus}
                error={error}
                multiple={fd.allowsMultiples}
                value={fieldValue}
                onChange={this.onSelectChange}
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                MenuProps={{
                  PaperProps: {
                    style: { maxHeight: 300 },
                  },
                }}
                onKeyPress={(event: any) => {
                  var keyPress = event.key;
                  var listID: string = "";
                  (options || []).map((o: any, i: number) => {
                    if (
                      listID === "" &&
                      o.label.toLowerCase().charAt(0) == keyPress.toLowerCase()
                    ) {
                      listID = fd.key + "_" + i;
                      if (document.getElementById(listID) != null) {
                        const el = document.getElementById(listID);
                        if (el) {
                          el.scrollIntoView({ behavior: "smooth" });
                        }
                      }
                    }
                  });
                  this.setState({ open: true });
                }}
              >
                {fd.mode != "Required" && !fd.defaultValue && (
                  <MenuItem value="_nullOption">{nullOptionLabel}</MenuItem>
                )}
                {options.map((c: any, idx: number) => {
                  //BRIAN
                  var menuClass = classes.defaultMenuItem;
                  if (c.variant) {
                    switch (c.variant) {
                      case "error":
                        menuClass = classes.errorMenuItem;
                        break;
                      case "important":
                        menuClass = classes.importantMenuItem;
                        break;
                    }
                  }
                  return (
                    <MenuItem
                      id={fd.key + "_" + idx}
                      key={idx}
                      className={menuClass}
                      value={c.value}
                    >
                      {c.label}
                    </MenuItem>
                  );
                })}
              </Select>
              {helperText && (
                <FormHelperText error={error}>{helperText}</FormHelperText>
              )}
            </FormControl>
          );
          break;
        case "ImageList":
          return (
            <ImageList
              policyMessages={policyMessages}
              path={path}
              definition={fd}
              data={fieldValue}
              hidePublicSelector={true}
              onImageListChange={this.onDirectChange(false)}
            />
          );
          break;
        case "Relation":
          var options = this.filterConditionalOptions(fd.options);

          if (fd.variant == "Checkbox") {
            return (
              <FormControl
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                error={error}
                style={{ display: "list-item", listStyle: "none" }}
                component="fieldset"
              >
                <FormLabel component="legend">{fd.title}</FormLabel>
                <FormGroup style={{ display: "inline-block" }}>
                  {options.map((o: any) => {
                    return (
                      <FormControlLabel
                        key={o.value}
                        control={
                          <Checkbox
                            // id={o.value}
                            inputProps={{
                              autoComplete: autofillString,
                              name: o.value,
                            }}
                            checked={this.checkedValue(o.value)}
                            onChange={this.onCheckboxOptionChange.bind(
                              this,
                              o.value
                            )}
                            value={o.value}
                            color="primary"
                            disabled={
                              fd.mode == "Read Only" || this.props.readOnly
                            }
                          />
                        }
                        label={o.label}
                      />
                    );
                  })}
                </FormGroup>

                {helperText && <FormHelperText>{helperText}</FormHelperText>}
              </FormControl>
            );
          }

          let rfVal = "";
          if (value == null) {
            rfValue = "_nullOption";
          } else if (value && value.label) {
            rfVal = value.label;
          }

          return (
            <FormControl
              disabled={fd.mode == "Read Only" || this.props.readOnly}
              className={formDefClass}
              style={styleObj}
            >
              {/* <InputLabel
                error={error}
                shrink={shrink !== false || (value != null && value.length > 0)}
                required={fd.mode === 'Required'}
                htmlFor="select">
                {fd.title}
              </InputLabel> */}
              {fieldLabel}
              <Select
                // id={fd.key}
                name={fd.key}
                open={this.state.open}
                autoFocus={fd.autoFocus}
                error={error}
                multiple={fd.allowsMultiples}
                value={rfVal}
                onChange={this.onRelationSelectChange}
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                MenuProps={{
                  PaperProps: {
                    style: { maxHeight: 300 },
                  },
                }}
                onKeyPress={(event: any) => {
                  var keyPress = event.key;
                  var listID: string = "";
                  (options || []).map((o: any, i: number) => {
                    if (
                      listID === "" &&
                      o.label.toLowerCase().charAt(0) == keyPress.toLowerCase()
                    ) {
                      listID = fd.key + "_" + i;
                      if (document.getElementById(listID) != null) {
                        const el = document.getElementById(listID);
                        if (el) {
                          el.scrollIntoView({ behavior: "smooth" });
                        }
                      }
                    }
                  });
                  this.setState({ open: true });
                }}
              >
                {fd.mode != "Required" && !fd.defaultValue && (
                  <MenuItem key="_nullOption" value="_nullOption">
                    {nullOptionLabel}
                  </MenuItem>
                )}
                {options.map((c: any, idx: number) => {
                  return (
                    <MenuItem id={fd.key + "_" + idx} key={idx} value={c.label}>
                      {c.label}
                    </MenuItem>
                  );
                })}
              </Select>
              {helperText && (
                <FormHelperText error={error}>{helperText}</FormHelperText>
              )}
            </FormControl>
          );
      }
    }

    // Now look for the display mode.  Since display mode is intended largely for compact display, as in lists, little effort has been made to provide value lookups.  This should take place server-side as needed.
    if (fd.mode == "Display") {
      var label = (
        <InputLabel style={labelStyleObj} shrink>
          {fd.title}
        </InputLabel>
      );

      if (fd.fieldInfo && fd.fieldInfo.content) {
        label = (
          <InputLabel style={labelStyleObj} shrink>
            {fd.title}
            <div style={{ display: "inline-block" }}>
              <Poptart
                click={true}
                className="form-def-field-info"
                placement={fd.fieldInfo.popperPlacement || "top"}
                icon={`fa ${fd.fieldInfo.icon || "fa-question-circle"}`}
                timeout={350}
                iconStyle={{
                  display: "inline-block",
                  marginLeft: 5,
                }}
              >
                <div
                  style={{ width: fd.fieldInfo.popperWidth, padding: 5 }}
                  dangerouslySetInnerHTML={{
                    __html: fd.fieldInfo.content,
                  }}
                ></div>
              </Poptart>
            </div>
          </InputLabel>
        );
      }
      switch (fd.type) {
        case "Address":
          return (
            <FormControl className={formDefClass} style={styleObj}>
              <InputLabel style={labelStyleObj} shrink>
                {fd.title}
              </InputLabel>
              {displayValue && (
                <div className={classes.displayText}>
                  <address className={classes.container}>
                    <div>{displayValue.address1}</div>
                    <div>{displayValue.address2}</div>
                    <div>{displayValue.address3 || ""}</div>
                    <div>{displayValue.county || ""}</div>
                    <div>
                      {displayValue.city}, {displayValue.state}{" "}
                      {displayValue.postalCode}, {displayValue.country || ""}
                    </div>
                  </address>
                </div>
              )}
              {!displayValue && "--"}
            </FormControl>
          );
        case "RichText":
          return (
            <FormControl className={formDefClass} style={styleObj}>
              <InputLabel style={labelStyleObj} shrink>
                {fd.title}
              </InputLabel>
              {displayValue && (
                <div
                  className={classes.displayText}
                  dangerouslySetInnerHTML={{ __html: displayValue }}
                />
              )}
              {!displayValue && "--"}
            </FormControl>
          );
        case "ImageList":
          return (
            <ImageList
              policyMessages={policyMessages}
              path={path}
              definition={fd}
              data={fieldValue}
              hidePublicSelector={true}
              onImageListChange={this.onDirectChange(false)}
            />
          );
          break;
        case "Relation":
          return (
            <FormControl
              className={formDefClass}
              style={styleObj}
              disabled={fd.mode == "Read Only" || this.props.readOnly}
            >
              <InputLabel style={labelStyleObj} shrink>
                {fd.title}
              </InputLabel>
              {displayValue && (
                <div
                  className={classes.displayText}
                  dangerouslySetInnerHTML={{ __html: displayValue }}
                />
              )}
              {!displayValue && (
                <div
                  className={classes.displayText}
                  dangerouslySetInnerHTML={{ __html: "--" }}
                />
              )}
            </FormControl>
          );
        case "Boolean":
          switch (fd.variant) {
            case "Checkbox":
              return (
                <FormControl
                  className={formDefClass}
                  style={{ display: "list-item", listStyle: "none" }}
                  component="fieldset"
                >
                  <div style={{ width: "100%" }}>
                    <FormControlLabel
                      control={
                        this.props.fieldDefinition.variant == "Radio" ? (
                          <Checkbox
                            // id={fd.key}
                            inputProps={{
                              autoComplete: autofillString,
                              name: fd.key,
                            }}
                            checked={value}
                            // onChange={this.onBooleanChange}
                            value={fd.key}
                            color="primary"
                            disabled={fd.mode == "Display"}
                          />
                        ) : (
                          <Radio
                            // id={fd.key}
                            inputProps={{
                              autoComplete: autofillString,
                              name: fd.key,
                            }}
                            checked={value}
                            // onChange={this.onBooleanChange}
                            value={fd.key}
                            color="primary"
                            disabled={fd.mode == "Display"}
                          />
                        )
                      }
                      label={fd.title}
                      // disabled={false}
                    />
                  </div>
                  {helperText && <FormHelperText>{helperText}</FormHelperText>}
                </FormControl>
              );
          }
        case "Text":
          
          if (fd.variant && fd.variant.toLowerCase().startsWith('chip')) {
            // May not currently be used?
              let inputProps = {};
              let InputProps = {};
              return (
                <ChipField
                required={fd.mode == "Required"}
                // id={fd.key}
                name={fd.key}
                value={fieldValue}
                label={label}
                className={formDefClass}
                error={error}
                helperText={helperText}
                placeholder={fd.placeholder || ""}
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink: shrink !== false || (value != null && value.length > 0),
                }}
                onBlur={this.onCommitChange}
                onChange={this.onChipChange}
                onKeyPress={this.onKeyPress}
                inputProps={inputProps}
                InputProps={InputProps}
                max={fd.maxValue}
                style={styleObj}
                shrink={shrink}
                isKeyField={fd.mode == "Key Field"}
                fieldDefinition={fd}
                onKeyDown={this.props.onKeyDown}
              />
              );
            // }
          }

        default:
          return (
            <FormControl className={formDefClass} style={styleObj}>
              {label}
              <div name={fd.key} className={classes.displayText}>
                {fd.type != "Json"
                  ? displayValue
                  : JSON.stringify(displayValue, null, 2)}
              </div>
            </FormControl>
          );
      }
    }

    // No options, so let's base the value on type
    if (fd.variant == "Checkbox") {
    }

    switch (fd.type) {
      case "Text":
        // The text field accepts BOTH `inputProps` and `InputProps`
        let inputProps = {};
        let InputProps = {};
        inputProps["autoComplete"] = autofillString;

        if (fd.maxLength) {
          inputProps["maxLength"] = fd.maxLength;
        }

        if (fd.variant == "Password") {
          InputProps["endAdornment"] = (
            <InputAdornment position="end">
              <IconButton size="large" tabIndex={-1} onClick={this.handleClickShowPasssword}>
                {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          );
        } else if (fd.validationAttributes && fd.validationAttributes.validationURL) {
          // VALIDATION FIELD STUFF
          if(fd.validationAttributes.validationOnly) {
            return (fd.mode == "Read Only" || this.props.readOnly) ? (<div></div>) : this.renderValidationAdornment(validationError, fd.validationAttributes.validationOnly, helperText);
          } else {
            InputProps["endAdornment"] = (fd.mode == "Read Only" || this.props.readOnly) ? undefined : this.renderValidationAdornment(validationError, fd.validationAttributes.validationOnly, helperText)
          }

          InputProps["endAdornment"] = (fd.mode == "Read Only" || this.props.readOnly) ? undefined : this.renderValidationAdornment(validationError, false, helperText)
        }

        if (fd.mask) {
          return (
            <InputMask
              mask={fd.mask}
              value={fieldValue}
              disabled={fd.mode == "Read Only" || this.props.readOnly}
              onBlur={this.onCommitChange}
              onChange={this.onChange}
              maskChar=" "
            >
              {() => (
                <TextField
                  type={this.getTextFieldType(fd)}
                  required={fd.mode == "Required"}
                  // id={fd.key}
                  name={fd.key}
                  // value={fieldValue}
                  label={
                    <span>
                      {fd.title}
                      {fd.mode == "Key Field" && (
                        <i
                          style={{ color: "#CD5C5C", marginLeft: 5 }}
                          className="fa fa-key"
                        ></i>
                      )}
                    </span>
                  }
                  className={formDefClass}
                  placeholder={fd.placeholder || ""}
                  //This InputProps (capital I) is for the underlying Material IU Input component (which does not care about maxLenght, for example
                  InputProps={InputProps}
                  //This inputProps (little i) is for the html input control at the bottom.
                  inputProps={inputProps}
                  InputLabelProps={{
                    style: labelStyleObj,
                    shrink:
                      shrink !== false || (value != null && value.length > 0),
                  }}
                  onKeyPress={this.onKeyPress}
                  error={error}
                  helperText={helperText}
                  disabled={fd.mode == "Read Only" || this.props.readOnly}
                  multiline={fd.variant == "TextArea" ? true : false}
                  rows={
                    fd.variant == "TextArea" && fd.textAreaRowCount
                      ? fd.textAreaRowCount
                      : 2
                  }
                  style={styleObj}
                />
              )}
            </InputMask>
          );
        } else {
          // Apply any changes to the above (InputMask child) also
          if (fd.variant && fd.variant.toLowerCase().startsWith('chip')) {
            return (
              <ChipField
                required={fd.mode == "Required"}
                // id={fd.key}
                name={fd.key}
                value={fieldValue}
                label={fd.title}
                className={formDefClass}
                error={error}
                helperText={helperText}
                placeholder={fd.placeholder || ""}
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink: shrink !== false || (value != null && value.length > 0),
                }}
                onBlur={this.onCommitChange}
                onChange={this.onChipChange}
                onKeyPress={this.onKeyPress}
                inputProps={inputProps}
                InputProps={InputProps}
                max={fd.maxValue}
                style={styleObj}
                shrink={shrink}
                isKeyField={fd.mode == "Key Field"}
                fieldDefinition={fd}
                onKeyDown={this.props.onKeyDown}
              />
            );
          } else {

          var fieldInfoIcon
          if (fd.fieldInfo) {
            fieldInfoIcon = (
              <div style={{display: "inline-block"}}>
                <Poptart
                  click={true}
                  className="form-def-field-info"
                  placement={fd.fieldInfo.popperPlacement || "top"}
                  icon={`fa ${fd.fieldInfo.icon || "fa-question-circle"}`}
                  timeout={350}
                  iconStyle={{
                    display: "inline-block",
                    marginLeft: 5 
                  }}
                >
                  <div  style={{width: fd.fieldInfo.popperWidth, padding: 5}} dangerouslySetInnerHTML={{__html: fd.fieldInfo.content}}></div>
                </Poptart>
              </div>
            )
          }
          
            return (
              <TextField
                type={this.getTextFieldType(fd)}
                required={fd.mode == "Required"}
                // id={fd.key}
                name={fd.key}
                value={fieldValue}

                label={
                  <span>
                    {fd.title}
                    {fd.mode == "Key Field" && (
                      <i
                        style={{ color: "#CD5C5C", marginLeft: 5 }}
                        className="fa fa-key"
                      ></i>
                    )}
                    {fieldInfoIcon}
                  </span>
                }
                className={formDefClass}
                placeholder={fd.placeholder || ""}
                onChange={this.onChange}
                //This InputProps (capital I) is for the underlying Material IU Input component (which does not care about maxLenght, for example
                InputProps={InputProps}
                //This inputProps (little i) is for the html input control at the bottom.
                inputProps={inputProps}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink: shrink !== false || (value != null && value.length > 0),
                }}
                onKeyPress={this.onKeyPress}
                onBlur={this.onCommitChange}
                onPaste={fieldDefinition.allowedCharacters ? this.onPaste : null}
                onClick={this.onTextFieldClick}
                error={error}
                helperText={helperText}
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                multiline={fd.variant == "TextArea" ? true : false}
                rows={
                  fd.variant == "TextArea" && fd.textAreaRowCount
                    ? fd.textAreaRowCount
                    : 2
                }
                style={styleObj}
              />
            );
          }
        }
        break;
      case "Numeric":
      case "Number":
      case "Currency":
        let isInteger: boolean = false;
        if (
          (fd.precision == undefined || fd.precision != null) &&
          fd.precision == 0
        ) {
          isInteger = true;
        }
        return (
          <NumberField
            required={fd.mode == "Required"}
            // id={fd.key}
            name={fd.key}
            value={fieldValue}
            label={fd.title}
            className={formDefClass}
            error={error}
            helperText={helperText}
            disabled={fd.mode == "Read Only" || this.props.readOnly}
            integer={isInteger}
            InputLabelProps={{
              style: labelStyleObj,
              shrink: shrink !== false || (value != null && value.length > 0),
            }}
            currency={fd.type == "Currency"}
            onNumberChange={this.onDirectChange(false)}
            onBlur={this.onCommitChange}
            max={fd.maxValue}
            style={styleObj}
            precision={fd.precision}
            isKeyField={fd.mode == "Key Field"}
            onKeyDown={this.props.onKeyDown}
          />
        );
        break;
      case "Date":
        var minDate: any;
        var maxDate: any;
        // Check to see if we have min and max date
        if (fd.minDate) {
          minDate = evaluateDateLimit(fd.minDate);
        }
        if (fd.maxDate) {
          maxDate = evaluateDateLimit(fd.maxDate);
        }

        return (
          <DateField
            required={fd.mode == "Required"}
            // id={fd.key}
            autoOk={true}
            name={fd.key}
            value={fieldValue}
            label={fd.title}
            className={formDefClass}
            error={error}
            helperText={helperText}
            disabled={fd.mode == "Read Only" || this.props.readOnly}
            onChange={this.onDateChange}
            InputLabelProps={{
              style: labelStyleObj,
              shrink: shrink !== false || (value != null && value.length > 0),
            }}
            style={styleObj}
            maxDate={maxDate}
            minDate={minDate}
            isKeyField={fd.mode == "Key Field"}
          />
        );
        break;

      case "DateTime":
      case "Time":
        var minDate: any;
        var maxDate: any;
        // Check to see if we have min and max date
        if (fd.minDate) {
          minDate = evaluateDateLimit(fd.minDate);
        }
        if (fd.maxDate) {
          maxDate = evaluateDateLimit(fd.maxDate);
        }

        return (
          <TimeField
            required={fd.mode == "Required"}
            autoOk={true}
            name={fd.key}
            value={fieldValue}
            label={fd.title}
            className={formDefClass}
            error={error}
            helperText={helperText}
            disabled={fd.mode == "Read Only" || this.props.readOnly}
            onChange={this.onDateChange}
            InputLabelProps={{
              style: labelStyleObj,
              shrink: shrink !== false || (value != null && value.length > 0),
            }}
            style={styleObj}
            maxDate={maxDate}
            minDate={minDate}
            isKeyField={fd.mode == "Key Field"}
          />
        );
        break;
      
      case "Bool":
      case "Boolean":
        switch (fd.variant) {
          case "Checkbox":
            var checkClass = "check-optional";
            if (fd.mode == "Required") {
              checkClass = "check-required";
            }

            return (
              <FormControl
                error={error}
                style={{ display: "list-item", listStyle: "none" }}
                className={classes.checkBoxRequired}
                component="fieldset"
              >
                <div style={{ width: "100%" }}>
                  <FormControlLabel
                    className={checkClass}
                    control={
                      this.props.fieldDefinition.variant == "Radio" ? (
                        <Radio
                          // id={fd.key}
                          inputProps={{
                            autoComplete: autofillString,
                            name: fd.key,
                          }}
                          checked={value}
                          required={true}
                          onChange={this.onBooleanChange}
                          value={fd.key}
                          color="primary"
                          disabled={
                            fd.mode == "Read Only" || this.props.readOnly
                          }
                        />
                      ) : (
                        <Checkbox
                          // id={fd.key}
                          inputProps={{
                            autoComplete: autofillString,
                            name: fd.key,
                          }}
                          checked={value}
                          required={true}
                          onChange={this.onBooleanChange}
                          value={fd.key}
                          color="primary"
                          disabled={
                            fd.mode == "Read Only" || this.props.readOnly
                          }
                        />
                      )
                    }
                    label={fd.title}
                  />
                </div>
                {helperText && <FormHelperText>{helperText}</FormHelperText>}
              </FormControl>
            );
          default:
            return (
              <FormControl error={error} component="fieldset" style={styleObj}>
                
                <FormControlLabel
                  control={
                    <Switch
                      // id={fd.key}
                      name={fd.key}
                      checked={value && value == true ? true : false}
                      onChange={this.onBooleanChange}
                      value={fd.key}
                      color="primary"
                    />
                  }
                  label={fd.title || ""}
                />

                {helperText && <FormHelperText>{helperText}</FormHelperText>}
              </FormControl>
            );
        }
        break;
      case "VersionedDocument":
        return (
          <VersionedDocumentField
            onFileReject={this.props.onFileReject}
            minimal
            required={fd.mode == "Required"}
            readOnly={fd.mode == "Read Only" || this.props.readOnly}
            defaultDocumentURL={fd.defaultDocumentURL}
            label={fd.title}
            hideVersions={fd.suppressVersions}
            error={error}
            helperText={helperText}
            onVersionedDocumentChange={this.onDirectChange(false)}
            preventDelete={false}
            versionedDocument={fieldValue}
            parse={fd.parse}
            accept={fd.acceptedDocumentTypes}
            style={styleObj}
            maxSize={fd.maxSize}
          />
        );
      case "VersionedDocumentList":
        return (
          <VersionedDocumentList
            minimal
            required={fd.mode == "Required"}
            readOnly={fd.mode == "Read Only" || this.props.readOnly}
            label={fd.title}
            error={error}
            helperText={helperText}
            errorTextVal={errorTextVal}
            preventDelete={false}
            parse={fd.parse}
            maxCombinedSize={fd.maxCombinedSize || 0}
            accept={fd.acceptedDocumentTypes}
            style={styleObj}
            versionedDocuments={fieldValue}
            onVersionedDocumentChange={this.onDirectChange(false)}
            maxSize={fd.maxSize}
          />
        );
      case "DocumentList":
        return (
          <DocumentList
            minimal
            required={fd.mode == "Required"}
            label={fd.title}
            error={error}
            errorTextVal={errorTextVal}
            helperText={helperText}
            preventDelete={false}
            parse={fd.parse}
            accept={fd.acceptedDocumentTypes}
            style={styleObj}
            documents={fieldValue}
            onDocumentsChange={this.onDirectChange(false)}
            fieldDefinition={fd}
            hidePublicSelector={fd.hidePublicSelector}
            maxSize={fd.maxSize}
          />
        );

      case "NumericRange":
        {
          /* TODO Apply Min/Max */
        }
        return (
          <Grid container spacing={1}>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
              <NumberField
                required={fd.mode == "Required"}
                // id={fd.key + 'From'}
                name={fd.key + "From"}
                value={fieldValue ? fieldValue["from"] : ""}
                label={fd.title + " From"}
                className={classNames(classes.rangeFieldFrom, formDefClass)}
                error={error}
                helperText={helperText}
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                integer={false}
                precision={fd.precision}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink:
                    shrink !== false || (value != null && value.length > 0),
                }}
                currency={
                  fd.variant && fd.variant.toLowerCase() == "currency"
                    ? true
                    : false
                }
                onNumberChange={this.onNumericRangeChange.bind(this, "from")}
                max={fd.maxValue}
                style={styleObj}
                isKeyField={fd.mode == "Key Field"}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
              <NumberField
                required={fd.mode == "Required"}
                // id={fd.key + 'To'}
                name={fd.key + "To"}
                value={fieldValue ? fieldValue["to"] : ""}
                label={fd.title + " To"}
                className={classNames(classes.rangeFieldTo, formDefClass)}
                error={error}
                helperText={helperText}
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                integer={false}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink:
                    shrink !== false || (value != null && value.length > 0),
                }}
                currency={
                  fd.variant && fd.variant.toLowerCase() == "currency"
                    ? true
                    : false
                }
                onNumberChange={this.onNumericRangeChange.bind(this, "to")}
                max={fd.maxValue}
                style={styleObj}
                isKeyField={fd.mode == "Key Field"}
                precision={fd.precision}
              />
            </Grid>
          </Grid>
        );

      case "DateRange":
        if (fd.minDate) {
          minDate = evaluateDateLimit(fd.minDate);
        }
        if (fd.maxDate) {
          maxDate = evaluateDateLimit(fd.maxDate);
        }

        // Evaluate policy messages to determine if any apply to this rannge field.
        // distribute policy message to the from/to fields using policy extended attributes.

        var fromError, toError;
        var fromHelperText, toHelperText;

        if (this.props.policyMessages) {
          this.props.policyMessages.forEach((pm: any) => {
            if (pm.path == path) {
              if (pm.extendedAttributes && pm.extendedAttributes.to) {
                toHelperText = pm.message;
                toError = true;
              }
              if (pm.extendedAttributes && pm.extendedAttributes.from) {
                fromHelperText = pm.message;
                fromError = true;
              }
            }
          });
        }

        return (
          <Grid container spacing={1}>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
              <DateField
                required={fd.mode == "Required"}
                // id={fd.key + 'From'}
                name={fd.key + "From"}
                autoOk={true}
                value={fieldValue ? fieldValue["from"] : undefined}
                label={fd.title + " From"}
                className={classNames(classes.rangeFieldFrom, formDefClass)}
                error={fromError}
                startOfDay={true}
                helperText={fromHelperText}
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                minDate={minDate}
                maxDate={maxDate}
                onChange={this.onDateRangeChange.bind(this, "from")}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink:
                    shrink !== false || (value != null && value.length > 0),
                }}
                style={styleObj}
                isKeyField={fd.mode == "Key Field"}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
              <DateField
                required={fd.mode == "Required"}
                // id={fd.key + 'To'}
                autoOk={true}
                name={fd.key + "To"}
                value={fieldValue ? fieldValue["to"] : undefined}
                label={fd.title + " To"}
                className={classNames(classes.rangeFieldTo, formDefClass)}
                error={toError}
                endOfDay={true}
                helperText={toHelperText}
                minDate={minDate}
                maxDate={maxDate}
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                onChange={this.onDateRangeChange.bind(this, "to")}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink:
                    shrink !== false || (value != null && value.length > 0),
                }}
                style={styleObj}
                isKeyField={fd.mode == "Key Field"}
              />
            </Grid>
          </Grid>
        );
      case "TimeRange":
        if (fd.minDate) {
          minDate = evaluateDateLimit(fd.minDate);
        }
        if (fd.maxDate) {
          maxDate = evaluateDateLimit(fd.maxDate);
        }

        // Evaluate policy messages to determine if any apply to this rannge field.
        // distribute policy message to the from/to fields using policy extended attributes.

        var fromError, toError;
        var fromHelperText, toHelperText;

        if (this.props.policyMessages) {
          this.props.policyMessages.forEach((pm: any) => {
            if (pm.path == path) {
              if (pm.extendedAttributes && pm.extendedAttributes.to) {
                toHelperText = pm.message;
                toError = true;
              }
              if (pm.extendedAttributes && pm.extendedAttributes.from) {
                fromHelperText = pm.message;
                fromError = true;
              }
            }
          });
        }

        return (
          <Grid container spacing={1}>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
              <TimeField
                required={fd.mode == "Required"}
                // id={fd.key + 'From'}
                name={fd.key + "From"}
                autoOk={true}
                value={fieldValue ? fieldValue["from"] : undefined}
                label={fd.title + " From"}
                className={classNames(classes.rangeFieldFrom, formDefClass)}
                error={fromError}
                startOfDay={true}
                isRange={true}
                helperText={fromHelperText}
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                minDate={minDate}
                maxDate={maxDate}
                onChange={this.onDateRangeChange.bind(this, "from")}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink:
                    shrink !== false || (value != null && value.length > 0),
                }}
                style={styleObj}
                isKeyField={fd.mode == "Key Field"}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
              <TimeField
                required={fd.mode == "Required"}
                // id={fd.key + 'To'}
                autoOk={true}
                name={fd.key + "To"}
                value={fieldValue ? fieldValue["to"] : undefined}
                label={fd.title + " To"}
                className={classNames(classes.rangeFieldTo, formDefClass)}
                error={toError}
                isRange={true}
                endOfDay={true}
                helperText={toHelperText}
                minDate={minDate}
                maxDate={maxDate}
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                onChange={this.onDateRangeChange.bind(this, "to")}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink:
                    shrink !== false || (value != null && value.length > 0),
                }}
                style={styleObj}
                isKeyField={fd.mode == "Key Field"}
              />
            </Grid>
          </Grid>
        );
      case "PortalUser":
        return (
          <FormControl className={formDefClass}>
            <InputLabel
              error={error}
              style={labelStyleObj}
              shrink
              required={fd.mode == "Required"}
            >
              {fd.title}
            </InputLabel>
            <AutoSuggest
              menuWidth={500}
              displayClearAdornment={fd.mode != "Read Only"}
              emitClear={true}
              maxHeight={200}
              // id="portalUser"
              name="portalUser"
              minQueryChars={fd.minQueryChars || 3}
              preventBusyTab={true}
              autoSelectOptions={false}
              classes={{}}
              fetchSuggestions={this.fetchPortalUserSuggestions}
              value={this.getPortalUserValue()}
              onSuggestionSelected={this.onPortalUserSelect({}, this)}
              placeholder="Search users..."
              disabled={fd.mode == "Read Only" || this.props.readOnly}
            ></AutoSuggest>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
          </FormControl>
        );
      case "Address":
        if (value == null) {
          fieldValue = "_nullOption";
        }
        var address1 = <div></div>;
        if (
          !fd.addressAttributes ||
          !fd.addressAttributes.address1 ||
          fd.addressAttributes.address1.mode != "Hidden"
        ) {
          let InputProps = {};
          if (fd.validationAttributes && fd.validationAttributes.validationURL) {
            InputProps["endAdornment"] = (fd.mode == "Read Only" || this.props.readOnly) ? undefined : this.renderValidationAdornment(error, false, helperText)
          }
          
          address1 = (
            <Grid
              item
              xs={
                (fd.addressAttributes &&
                  fd.addressAttributes.address1 &&
                  fd.addressAttributes.address1.gridAttributes &&
                  fd.addressAttributes.address1.gridAttributes.xs) ||
                12
              }
              sm={
                (fd.addressAttributes &&
                  fd.addressAttributes.address1 &&
                  fd.addressAttributes.address1.gridAttributes &&
                  fd.addressAttributes.address1.gridAttributes.sm) ||
                12
              }
              md={
                (fd.addressAttributes &&
                  fd.addressAttributes.address1 &&
                  fd.addressAttributes.address1.gridAttributes &&
                  fd.addressAttributes.address1.gridAttributes.md) ||
                12
              }
              lg={
                (fd.addressAttributes &&
                  fd.addressAttributes.address1 &&
                  fd.addressAttributes.address1.gridAttributes &&
                  fd.addressAttributes.address1.gridAttributes.lg) ||
                12
              }
              xl={
                (fd.addressAttributes &&
                  fd.addressAttributes.address1 &&
                  fd.addressAttributes.address1.gridAttributes &&
                  fd.addressAttributes.address1.gridAttributes.xl) ||
                12
              }
            >
              <TextField
                type={this.getTextFieldType(fd)}
                required={
                  fd.mode == "Required" &&
                  (!fd.addressAttributes ||
                    !fd.addressAttributes.address1 ||
                    !fd.addressAttributes.address1.mode ||
                    fd.addressAttributes.address1.mode == "Required")
                }
                // id={fd.key + 'Address1'}
                name={fd.key + "Address1"}
                value={fieldValue ? fieldValue["address1"] : ""}
                label={
                  (fd.addressAttributes &&
                    fd.addressAttributes.address1 &&
                    fd.addressAttributes.address1.label) ||
                  "Address 1"
                }
                className={formDefClass}
                onChange={this.onAddressChange.bind(this, "address1")}
                InputProps={InputProps}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink:
                    shrink !== false || (value != null && value.length > 0),
                }}
                inputProps={{
                  autoComplete: autofillString,
                }}
                onBlur={this.onAdadaddressCommitChange.bind(this, "address1")}
                error={invalidAddress1}
                helperText={invalidAddress1 ? invalidAddress1Message : ""}
                disabled={
                  fd.mode == "Read Only" ||
                  (fd.addressAttributes &&
                    fd.addressAttributes.address1 &&
                    fd.addressAttributes.address1.mode &&
                    fd.addressAttributes.address1.mode == "Read Only") ||
                  this.props.readOnly
                }
              />
            </Grid>
          );
        }

        var address2 = <div></div>;
        if (
          !fd.addressAttributes ||
          !fd.addressAttributes.address2 ||
          fd.addressAttributes.address2.mode != "Hidden"
        ) {
          address2 = (
            <Grid
              item
              xs={
                (fd.addressAttributes &&
                  fd.addressAttributes.address2 &&
                  fd.addressAttributes.address2.gridAttributes &&
                  fd.addressAttributes.address2.gridAttributes.xs) ||
                12
              }
              sm={
                (fd.addressAttributes &&
                  fd.addressAttributes.address2 &&
                  fd.addressAttributes.address2.gridAttributes &&
                  fd.addressAttributes.address2.gridAttributes.sm) ||
                12
              }
              md={
                (fd.addressAttributes &&
                  fd.addressAttributes.address2 &&
                  fd.addressAttributes.address2.gridAttributes &&
                  fd.addressAttributes.address2.gridAttributes.md) ||
                12
              }
              lg={
                (fd.addressAttributes &&
                  fd.addressAttributes.address2 &&
                  fd.addressAttributes.address2.gridAttributes &&
                  fd.addressAttributes.address2.gridAttributes.lg) ||
                12
              }
              xl={
                (fd.addressAttributes &&
                  fd.addressAttributes.address2 &&
                  fd.addressAttributes.address2.gridAttributes &&
                  fd.addressAttributes.address2.gridAttributes.xl) ||
                12
              }
            >
              <TextField
                type={this.getTextFieldType(fd)}
                required={
                  fd.mode == "Required" &&
                  fd.addressAttributes &&
                  fd.addressAttributes.address2 &&
                  fd.addressAttributes.address2.mode &&
                  fd.addressAttributes.address2.mode == "Required"
                }
                // id={fd.key + 'Address2'}
                name={fd.key + "Address2"}
                value={fieldValue ? fieldValue["address2"] : ""}
                label={
                  (fd.addressAttributes &&
                    fd.addressAttributes.address2 &&
                    fd.addressAttributes.address2.label) ||
                  "Address 2"
                }
                className={formDefClass}
                onChange={this.onAddressChange.bind(this, "address2")}
                inputProps={{
                  autoComplete: autofillString,
                }}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink:
                    shrink !== false || (value != null && value.length > 0),
                }}
                onBlur={this.onAdadaddressCommitChange.bind(this, "address2")}
                error={invalidAddress2}
                helperText={invalidAddress2 ? invalidAddress2Message : ""}
                disabled={
                  fd.mode == "Read Only" ||
                  (fd.addressAttributes &&
                    fd.addressAttributes.address2 &&
                    fd.addressAttributes.address2.mode &&
                    fd.addressAttributes.address2.mode == "Read Only") ||
                  this.props.readOnly
                }
              />
            </Grid>
          );
        }

        var address3 = <div></div>;
        if (
          fd.addressAttributes &&
          fd.addressAttributes.address3 &&
          fd.addressAttributes.address3.mode &&
          fd.addressAttributes.address3.mode != "Hidden"
        ) {
          address3 = (
            <Grid
              item
              xs={
                (fd.addressAttributes &&
                  fd.addressAttributes.address3 &&
                  fd.addressAttributes.address3.gridAttributes &&
                  fd.addressAttributes.address3.gridAttributes.xs) ||
                12
              }
              sm={
                (fd.addressAttributes &&
                  fd.addressAttributes.address3 &&
                  fd.addressAttributes.address3.gridAttributes &&
                  fd.addressAttributes.address3.gridAttributes.sm) ||
                12
              }
              md={
                (fd.addressAttributes &&
                  fd.addressAttributes.address3 &&
                  fd.addressAttributes.address3.gridAttributes &&
                  fd.addressAttributes.address3.gridAttributes.md) ||
                12
              }
              lg={
                (fd.addressAttributes &&
                  fd.addressAttributes.address3 &&
                  fd.addressAttributes.address3.gridAttributes &&
                  fd.addressAttributes.address3.gridAttributes.lg) ||
                12
              }
              xl={
                (fd.addressAttributes &&
                  fd.addressAttributes.address3 &&
                  fd.addressAttributes.address3.gridAttributes &&
                  fd.addressAttributes.address3.gridAttributes.xl) ||
                12
              }
            >
              <TextField
                type={this.getTextFieldType(fd)}
                required={
                  fd.mode == "Required" &&
                  fd.addressAttributes &&
                  fd.addressAttributes.address3 &&
                  fd.addressAttributes.address3.mode &&
                  fd.addressAttributes.address3.mode == "Required"
                }
                // id={fd.key + 'Address3'}
                name={fd.key + "Address3"}
                value={fieldValue ? fieldValue["address3"] : ""}
                label={
                  (fd.addressAttributes &&
                    fd.addressAttributes.address3 &&
                    fd.addressAttributes.address3.label) ||
                  "Address 3"
                }
                className={formDefClass}
                onChange={this.onAddressChange.bind(this, "address3")}
                inputProps={{
                  autoComplete: autofillString,
                }}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink:
                    shrink !== false || (value != null && value.length > 0),
                }}
                onBlur={this.onAdadaddressCommitChange.bind(this, "address3")}
                error={invalidAddress3}
                helperText={invalidAddress3 ? invalidAddress3Message : ""}
                disabled={
                  fd.mode == "Read Only" ||
                  (fd.addressAttributes &&
                    fd.addressAttributes.address3 &&
                    fd.addressAttributes.address3.mode &&
                    fd.addressAttributes.address3.mode == "Read Only") ||
                  this.props.readOnly
                }
              />
            </Grid>
          );
        }

        var city = <div></div>;
        if (
          !fd.addressAttributes ||
          !fd.addressAttributes.city ||
          fd.addressAttributes.city.mode != "Hidden"
        ) {
          city = (
            <Grid
              item
              xs={
                (fd.addressAttributes &&
                  fd.addressAttributes.city &&
                  fd.addressAttributes.city.gridAttributes &&
                  fd.addressAttributes.city.gridAttributes.xs) ||
                6
              }
              sm={
                (fd.addressAttributes &&
                  fd.addressAttributes.city &&
                  fd.addressAttributes.city.gridAttributes &&
                  fd.addressAttributes.city.gridAttributes.sm) ||
                6
              }
              md={
                (fd.addressAttributes &&
                  fd.addressAttributes.city &&
                  fd.addressAttributes.city.gridAttributes &&
                  fd.addressAttributes.city.gridAttributes.md) ||
                6
              }
              lg={
                (fd.addressAttributes &&
                  fd.addressAttributes.city &&
                  fd.addressAttributes.city.gridAttributes &&
                  fd.addressAttributes.city.gridAttributes.lg) ||
                6
              }
              xl={
                (fd.addressAttributes &&
                  fd.addressAttributes.city &&
                  fd.addressAttributes.city.gridAttributes &&
                  fd.addressAttributes.city.gridAttributes.xl) ||
                6
              }
            >
              <TextField
                type={this.getTextFieldType(fd)}
                required={
                  fd.mode == "Required" &&
                  (!fd.addressAttributes ||
                    !fd.addressAttributes.city ||
                    !fd.addressAttributes.city.mode ||
                    fd.addressAttributes.city.mode == "Required")
                }
                // id={fd.key + 'City'}
                name={fd.key + "City"}
                value={fieldValue ? fieldValue["city"] : ""}
                label={
                  (fd.addressAttributes &&
                    fd.addressAttributes.city &&
                    fd.addressAttributes.city.label) ||
                  "City"
                }
                className={formDefClass}
                onChange={this.onAddressChange.bind(this, "city")}
                inputProps={{
                  autoComplete: autofillString,
                }}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink:
                    shrink !== false || (value != null && value.length > 0),
                }}
                onBlur={this.onAdadaddressCommitChange.bind(this, "city")}
                error={invalidCity}
                helperText={invalidCity ? invalidCityMessage : ""}
                disabled={
                  fd.mode == "Read Only" ||
                  (fd.addressAttributes &&
                    fd.addressAttributes.city &&
                    fd.addressAttributes.city.mode &&
                    fd.addressAttributes.city.mode == "Read Only") ||
                  this.props.readOnly
                }
              />
            </Grid>
          );
        }

        var county = <div></div>;
        if (
          fd.addressAttributes &&
          fd.addressAttributes.county &&
          fd.addressAttributes.county.mode &&
          fd.addressAttributes.county.mode != "Hidden"
        ) {
          county = (
            <Grid
              item
              xs={
                (fd.addressAttributes &&
                  fd.addressAttributes.county &&
                  fd.addressAttributes.county.gridAttributes &&
                  fd.addressAttributes.county.gridAttributes.xs) ||
                12
              }
              sm={
                (fd.addressAttributes &&
                  fd.addressAttributes.county &&
                  fd.addressAttributes.county.gridAttributes &&
                  fd.addressAttributes.county.gridAttributes.sm) ||
                12
              }
              md={
                (fd.addressAttributes &&
                  fd.addressAttributes.county &&
                  fd.addressAttributes.county.gridAttributes &&
                  fd.addressAttributes.county.gridAttributes.md) ||
                12
              }
              lg={
                (fd.addressAttributes &&
                  fd.addressAttributes.county &&
                  fd.addressAttributes.county.gridAttributes &&
                  fd.addressAttributes.county.gridAttributes.lg) ||
                12
              }
              xl={
                (fd.addressAttributes &&
                  fd.addressAttributes.county &&
                  fd.addressAttributes.county.gridAttributes &&
                  fd.addressAttributes.county.gridAttributes.xl) ||
                12
              }
            >
              <TextField
                type={this.getTextFieldType(fd)}
                required={
                  fd.mode == "Required" &&
                  fd.addressAttributes &&
                  fd.addressAttributes.county &&
                  fd.addressAttributes.county.mode &&
                  fd.addressAttributes.county.mode == "Required"
                }
                name={fd.key + "County"}
                value={fieldValue ? fieldValue["county"] : ""}
                label={
                  (fd.addressAttributes &&
                    fd.addressAttributes.county &&
                    fd.addressAttributes.county.label) ||
                  "County"
                }
                className={formDefClass}
                onChange={this.onAddressChange.bind(this, "county")}
                inputProps={{
                  autoComplete: autofillString,
                }}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink:
                    shrink !== false || (value != null && value.length > 0),
                }}
                onBlur={this.onAdadaddressCommitChange.bind(this, "county")}
                error={invalidCounty}
                helperText={invalidCounty ? invalidCountyMessage : ""}
                disabled={
                  fd.mode == "Read Only" ||
                  (fd.addressAttributes &&
                    fd.addressAttributes.county &&
                    fd.addressAttributes.county.mode &&
                    fd.addressAttributes.county.mode == "Read Only") ||
                  this.props.readOnly
                }
              />
            </Grid>
          );
        }

        var state = <div></div>;
        if (
          !fd.addressAttributes ||
          !fd.addressAttributes.state ||
          fd.addressAttributes.state.mode != "Hidden"
        ) {
          state = (
            <Grid
              item
              xs={
                (fd.addressAttributes &&
                  fd.addressAttributes.state &&
                  fd.addressAttributes.state.gridAttributes &&
                  fd.addressAttributes.state.gridAttributes.xs) ||
                2
              }
              sm={
                (fd.addressAttributes &&
                  fd.addressAttributes.state &&
                  fd.addressAttributes.state.gridAttributes &&
                  fd.addressAttributes.state.gridAttributes.sm) ||
                2
              }
              md={
                (fd.addressAttributes &&
                  fd.addressAttributes.state &&
                  fd.addressAttributes.state.gridAttributes &&
                  fd.addressAttributes.state.gridAttributes.md) ||
                2
              }
              lg={
                (fd.addressAttributes &&
                  fd.addressAttributes.state &&
                  fd.addressAttributes.state.gridAttributes &&
                  fd.addressAttributes.state.gridAttributes.lg) ||
                2
              }
              xl={
                (fd.addressAttributes &&
                  fd.addressAttributes.state &&
                  fd.addressAttributes.state.gridAttributes &&
                  fd.addressAttributes.state.gridAttributes.xl) ||
                2
              }
            >
             
              {this.renderStateField(
                fd,
                fieldValue,
                formDefClass,
                helperText,
                invalidState,
                styleObj,
                labelStyleObj,
                shrink,
                nullOptionLabel, 
                invalidStateMessage
              )}

            </Grid>
          );
        }

        var postalCode = <div></div>;
        if (
          !fd.addressAttributes ||
          !fd.addressAttributes.postalCode ||
          fd.addressAttributes.postalCode.mode != "Hidden"
        ) {
          var postalCodeTextField = (
          <TextField
            type={this.getTextFieldType(fd)}
            required={
              fd.mode == "Required" &&
              (!fd.addressAttributes ||
                !fd.addressAttributes.postalCode ||
                !fd.addressAttributes.postalCode.mode ||
                fd.addressAttributes.postalCode.mode == "Required")
            }
            // id={fd.key + 'PortalCode'}
            name={fd.key + "PortalCode"}
            value={fieldValue ? fieldValue["postalCode"] : ""}
            label={
              (fd.addressAttributes &&
                fd.addressAttributes.postalCode &&
                fd.addressAttributes.postalCode.label) ||
              "Zip"
            }
            className={formDefClass}
            onChange={this.onAddressChange.bind(this, "postalCode")}
            inputProps={{
              autoComplete: autofillString,
            }}
            InputLabelProps={{
              style: labelStyleObj,
              shrink:
                shrink !== false || (value != null && value.length > 0),
            }}
            onBlur={this.onAdadaddressCommitChange.bind(this, "postalCode")}
            error={invalidPostalCode}
            helperText={invalidPostalCode ? invalidPostalCodeMessage : ""}
            disabled={
              fd.mode == "Read Only" ||
              (fd.addressAttributes &&
                fd.addressAttributes.postalCode &&
                fd.addressAttributes.postalCode.mode &&
                fd.addressAttributes.postalCode.mode == "Read Only") ||
              this.props.readOnly
            }
          />)


          var postalCodeFullField = postalCodeTextField
            if (fd.addressAttributes &&
              fd.addressAttributes.postalCode && 
              fd.addressAttributes.postalCode.mask) {
              postalCodeFullField = (
                <InputMask
                mask={fd.addressAttributes.postalCode.mask}
                value={fieldValue ? fieldValue["postalCode"] : ""}
                disabled={fd.mode == "Read Only" || this.props.readOnly}
                onBlur={this.onAdadaddressCommitChange.bind(this, "postalCode")}
                onChange={this.onAddressChange.bind(this, "postalCode")}
                maskChar=" "
                >
                  {() => (
                    <TextField
                    type={this.getTextFieldType(fd)}
                    required={
                      fd.mode == "Required" &&
                      (!fd.addressAttributes ||
                        !fd.addressAttributes.postalCode ||
                        !fd.addressAttributes.postalCode.mode ||
                        fd.addressAttributes.postalCode.mode == "Required")
                    }
                    // id={fd.key + 'PortalCode'}
                    name={fd.key + "PortalCode"}
                    
                    label={
                      (fd.addressAttributes &&
                        fd.addressAttributes.postalCode &&
                        fd.addressAttributes.postalCode.label) ||
                      "Zip"
                    }
                    className={formDefClass}
                    // onChange={this.onAddressChange.bind(this, "postalCode")}
                    inputProps={{
                      autoComplete: autofillString,
                    }}
                    InputLabelProps={{
                      style: labelStyleObj,
                      shrink:
                        shrink !== false || (value != null && value.length > 0),
                    }}
                    // onBlur={this.onAdadaddressCommitChange.bind(this, "postalCode")}
                    error={invalidPostalCode}
                    helperText={invalidPostalCode ? invalidPostalCodeMessage : ""}
                    disabled={
                      fd.mode == "Read Only" ||
                      (fd.addressAttributes &&
                        fd.addressAttributes.postalCode &&
                        fd.addressAttributes.postalCode.mode &&
                        fd.addressAttributes.postalCode.mode == "Read Only") ||
                      this.props.readOnly
                    }
                  />
              )}
                
                </InputMask>
              )
            }

          postalCode = (
            <Grid
              item
              xs={
                (fd.addressAttributes &&
                  fd.addressAttributes.postalCode &&
                  fd.addressAttributes.postalCode.gridAttributes &&
                  fd.addressAttributes.postalCode.gridAttributes.xs) ||
                4
              }
              sm={
                (fd.addressAttributes &&
                  fd.addressAttributes.postalCode &&
                  fd.addressAttributes.postalCode.gridAttributes &&
                  fd.addressAttributes.postalCode.gridAttributes.sm) ||
                4
              }
              md={
                (fd.addressAttributes &&
                  fd.addressAttributes.postalCode &&
                  fd.addressAttributes.postalCode.gridAttributes &&
                  fd.addressAttributes.postalCode.gridAttributes.md) ||
                4
              }
              lg={
                (fd.addressAttributes &&
                  fd.addressAttributes.postalCode &&
                  fd.addressAttributes.postalCode.gridAttributes &&
                  fd.addressAttributes.postalCode.gridAttributes.lg) ||
                4
              }
              xl={
                (fd.addressAttributes &&
                  fd.addressAttributes.postalCode &&
                  fd.addressAttributes.postalCode.gridAttributes &&
                  fd.addressAttributes.postalCode.gridAttributes.xl) ||
                4
              }
            >

              {postalCodeFullField}

            </Grid>
          );
        }

        var country = <div></div>;
        if (
          !fd.addressAttributes ||
          !fd.addressAttributes.country ||
          fd.addressAttributes.country.mode != "Hidden"
        ) {
          country = (
            <Grid
              item
              xs={
                (fd.addressAttributes &&
                  fd.addressAttributes.country &&
                  fd.addressAttributes.country.gridAttributes &&
                  fd.addressAttributes.country.gridAttributes.xs) ||
                12
              }
              sm={
                (fd.addressAttributes &&
                  fd.addressAttributes.country &&
                  fd.addressAttributes.country.gridAttributes &&
                  fd.addressAttributes.country.gridAttributes.sm) ||
                12
              }
              md={
                (fd.addressAttributes &&
                  fd.addressAttributes.country &&
                  fd.addressAttributes.country.gridAttributes &&
                  fd.addressAttributes.country.gridAttributes.md) ||
                12
              }
              lg={
                (fd.addressAttributes &&
                  fd.addressAttributes.country &&
                  fd.addressAttributes.country.gridAttributes &&
                  fd.addressAttributes.country.gridAttributes.lg) ||
                12
              }
              xl={
                (fd.addressAttributes &&
                  fd.addressAttributes.country &&
                  fd.addressAttributes.country.gridAttributes &&
                  fd.addressAttributes.country.gridAttributes.xl) ||
                12
              }
            >
              <TextField
                type={this.getTextFieldType(fd)}
                required={
                  fd.mode == "Required" &&
                  (!fd.addressAttributes ||
                    !fd.addressAttributes.country ||
                    !fd.addressAttributes.country.mode ||
                    fd.addressAttributes.country.mode == "Required")
                }
                // id={fd.key + 'Address3'}
                name={fd.key + "Country"}
                value={fieldValue ? fieldValue["country"] : ""}
                label={
                  (fd.addressAttributes &&
                    fd.addressAttributes.country &&
                    fd.addressAttributes.country.label) ||
                  "Country"
                }
                className={formDefClass}
                onChange={this.onAddressChange.bind(this, "country")}
                inputProps={{
                  autoComplete: autofillString,
                }}
                InputLabelProps={{
                  style: labelStyleObj,
                  shrink:
                    shrink !== false || (value != null && value.length > 0),
                }}
                onBlur={this.onAdadaddressCommitChange.bind(this, "country")}
                error={invalidCountry}
                helperText={invalidCountry ? invalidCountryMessage : ""}
                disabled={
                  fd.mode == "Read Only" ||
                  (fd.addressAttributes &&
                    fd.addressAttributes.country &&
                    fd.addressAttributes.country.mode &&
                    fd.addressAttributes.country.mode == "Read Only") ||
                  this.props.readOnly
                }
              />
            </Grid>
          );
        }

        return (
          <Grid container spacing={2}>
            <Grid
              key={"title" + fd.key}
              item
              // item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <InputLabel
                error={error}
                style={labelStyleObj}
                shrink
                required={fd.mode == "Required" && fd.title}
              >
                {fd.title}
              </InputLabel>
            </Grid>
            
            {/* This grid is to start a new line for address 1 if it does not take up the whole line */}
            <Grid
              key={"nr" + fd.key}
              className={classes.blankFormLine}
              item
              // item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              {/* {" "} */}
              <FormHelperText className={addressMessageClass} shrink > {invalidAddressHeaderMessage} </FormHelperText>
              
            </Grid>
            {/* Here are all the actual sub-fields, each of which is defined above, to account for individual sub-field modes from addressAttributes */}
            {address1}
            {address2}
            {address3}
            {county}
            {city}
            {state}
            {postalCode}
            {country}
          </Grid>
        );
      case "Json":
        return (
          <TextField
            type={this.getTextFieldType(fd)}
            required={fd.mode == "Required"}
            // id={fd.key}
            name={fd.key}
            value={JSON.stringify(fieldValue || {})}
            label={fd.title}
            className={formDefClass}
            placeholder={fd.placeholder || ""}
            onChange={this.onChange}
            InputLabelProps={{
              style: labelStyleObj,
              shrink: shrink !== false || (value != null && value.length > 0),
            }}
            onKeyPress={this.onKeyPress}
            onBlur={this.onCommitChange}
            error={error}
            helperText={helperText}
            disabled={fd.mode == "Read Only" || this.props.readOnly}
            InputProps={{
              endAdornment: endAdornment,
            }}
            inputProps={{
              autoComplete: autofillString,
            }}
            multiline={fd.variant == "TextArea" ? true : false}
            rows={
              fd.variant == "TextArea" && fd.textAreaRowCount
                ? fd.textAreaRowCount
                : 2
            }
            style={styleObj}
          />
        );

      case "ImageList":
        return (
          <ImageList
            path={path}
            definition={fd}
            data={fieldValue}
            error={error}
            hidePublicSelector={true}
            helperText={helperText}
            accept={fd.acceptedDocumentTypes}
            policyMessages={policyMessages}
            onImageListChange={this.onDirectChange(false)}
            readOnly={fd.mode == "Read Only" || this.props.readOnly}
          />
        );
        break;
      case "Relation":
        if (fd.variant == "1.0"){
          return (
            <RelationField
              title={fd.title}
              className={formDefClass}
              mode={fd.mode}
              error={error}
              shrink={shrink}
              fieldDefinition={fd}
              helpText={helperText}
              value={fieldValue}
              onRelationUpdate={this.onDirectChange(false)}
              autoSuggestURL={fd.autoSuggestURL}
              appendToQuery={fd.appendToQuery}
              disabled={fd.mode == "Read Only" || this.props.readOnly}
            ></RelationField>
          );
          
        } else {
          return (
            <Autocomplete
              title={fd.title}
              onAccessRootData={onAccessRootData}
              className={classNames(formDefClass, classes.autocomplete)}
              type={"Relation"}
              mode={fd.mode}
              data={data}
              error={errorTextVal}
              shrink={shrink}
              fieldDefinition={fd}
              helpText={helperText}
              classes={{}}
              value={fieldValue}
              onDirectUpdate={this.onNewDirectChange(false)}
              autoSuggestURL={fd.autoSuggestURL}
              appendToQuery={fd.appendToQuery}
              disabled={fd.mode == "Read Only" || this.props.readOnly}
            ></Autocomplete>
          );
        }

      case "RelationList":
        if (fd.variant == "1.0"){
          return (
            <RelationList
              helpText={fd.helpText}
              title={fd.title}
              fieldDefinition={fd}
              error={error}
              mode={fd.mode}
              value={value}
              onRelationChange={this.onDirectChange(false)}
              autoSuggestURL={fd.autoSuggestURL}
              appendToQuery={fd.appendToQuery}
              disabled={fd.mode == "Read Only" || this.props.readOnly}
            ></RelationList>
          );
        } else {
          return (
            <Autocomplete
              title={fd.title}
              type={"RelationList"}
              className={classNames(formDefClass, classes.autocomplete)}
              onAccessRootData={onAccessRootData}
              mode={fd.mode}
              data={data}
              error={errorTextVal}
              shrink={shrink}
              fieldDefinition={fd}
              helpText={helperText}
              classes={{}}
              value={fieldValue}
              onDirectUpdate={this.onNewDirectChange(false)}
              autoSuggestURL={fd.autoSuggestURL}
              appendToQuery={fd.appendToQuery}
              disabled={fd.mode == "Read Only" || this.props.readOnly}
            ></Autocomplete>
          );
        }


        case "Autocomplete":
          return (
            <Autocomplete
              title={fd.title}
              type={"Autocomplete"}
              className={classNames(formDefClass, classes.autocomplete)}
              onAccessRootData={onAccessRootData}
              mode={fd.mode}
              error={errorTextVal}
              data={data}
              shrink={shrink}
              fieldDefinition={fd}
              helpText={helperText}
              classes={{}}
              value={fieldValue}
              onDirectUpdate={this.onNewDirectChange(false)}
              autoSuggestURL={fd.autoSuggestURL}
              appendToQuery={fd.appendToQuery}
              disabled={fd.mode == "Read Only" || this.props.readOnly}
            ></Autocomplete>
          );

      case "RichText":
        let rtVal: string;
        if (flattenRichText) {
          rtVal = fieldValue;
        } else {
          rtVal = fieldValue.html;
        }

        var toolBarOptions;
        if (fd.richTextOptions && fd.richTextOptions.toolBarOptions) {
          toolBarOptions = {
            options: fd.richTextOptions.toolBarOptions,
          };
        }

        return (
          <FormControl
            error={error ? true : false}
            required
            margin="normal"
            className={formDefClass}
          >
            <InputLabel
              error={error}
              style={labelStyleObj}
              shrink={shrink !== false || (value != null && value.length > 0)}
              required={fd.mode == "Required"}
            >
              {fd.title}
            </InputLabel>
            <RichTextEditor
              classes={{}}
              value={rtVal}
              onTextChange={this.onRichTextCommitChange}
              minHeight={20}
              toolbarOptions={toolBarOptions}
              containerStyle={{ marginTop: 20 }}
            />
            {error && <FormHelperText>{errorTextVal}</FormHelperText>}
          </FormControl>
        );

      default:
        // Don't know what kind of field this is
        return <div>Unsupported type ({fd.type})</div>;
    }
  }
}

function evaluateDateLimit(dt: string): any {
  try {
    var dur: any;
    var regex = /([+-]?)\s*(\d+)\s*(\w+)+/;
    var parts = dt.toLowerCase().match(regex);

    if (parts && parts.length > 3) {
      const sign = parts[1];
      const qty = parts[2];
      const unit = parts[3];

      let val = parseInt(qty);
      if (sign == "-") {
        val = -1 * val;
      }

      switch (unit) {
        case "d":
        case "day":
        case "days":
          dur = moment.duration(val, "days");
          break;

        case "w":
        case "week":
        case "weeks":
          dur = moment.duration(val, "weeks");
          break;

        case "m":
        case "month":
        case "months":
          dur = moment.duration(val, "months");
          break;

        case "y":
        case "year":
        case "years":
          dur = moment.duration(val, "years");
          break;
      }
    }

    const limitDt = moment(new Date()).add(dur).toDate();
    return limitDt;
  } catch (e) {
    console.error(e);
  }
}

export const Field = withStyles(styles)(FormDefField);
